<!-- eslint-disable vue/multi-word-component-names -- component name is capitalised, and unlikely that html will introduce a similar tag -->
<!-- Copyright (c) 2024 Digital Systems (M) Sdn. Bhd. -->
<template>
  <div class="arinvoice-main">
    <div class="left-container" ref="leftContainer">
      <Menus :menu="menu" @menuClicked="menuClicked" />
    </div>
    <div class="right-container">
      <div class="top-section">
        <div class="filter-description">{{ filterText }}</div>
        <ButtonFilter
          class="button-filter-component"
          filterPosition="right"
          buttonText="Change Filter"
          :filterWidth="300"
          :isOpen.sync="mainFilterIsOpen"
          :buttonIsDisabled="mainFilterIsDisabled"
        >
          <div class="filter-popup">
            <BoxContainer
              title="Date"
              :isCheckBox="true"
              style="margin-bottom: 5px"
              :isChecked.sync="filterDateInvList"
            >
              <div class="row-display">
                <DateTimePicker
                  :showTime="false"
                  placeholder="From"
                  :isDisabled="!filterDateInvList"
                  :value.sync="fromInvoiceListingDate"
                  :errorMessage.sync="fromInvoiceListingDateErr"
                />
                <DateTimePicker
                  :showTime="false"
                  placeholder="To"
                  :isDisabled="!filterDateInvList"
                  :value.sync="toInvoiceListingDate"
                  :errorMessage.sync="toInvoiceListingDateErr"
                />
              </div>
            </BoxContainer>
            <BoxContainer
              title="Search"
              :isCheckBox="true"
              style="margin-botton: 5px"
              :isChecked.sync="filterSearchInvList"
            >
              <div>
                <Dropdown
                  ref="searchby"
                  placeholder="Search By"
                  :items="searchFilterItems"
                  itemKey="Search By"
                  :isDisabled="!filterSearchInvList"
                  :isRequired="filterSearchInvList"
                  :selectedObject.sync="searchByValue"
                  :errorMessage.sync="searchByErrorMessage"
                />
                <Dropdown
                  ref="searchcriteria"
                  placeholder="Search Criteria"
                  :items="searchCriteriaItems"
                  itemKey="name"
                  :isDisabled="!filterSearchInvList"
                  :isRequired="filterSearchInvList"
                  :selectedObject.sync="selectedFilterSearchCriteria"
                  :errorMessage.sync="searchCriteriaErrorMessage"
                />
                <Input
                  ref="search"
                  placeholder="Search"
                  :inputValue.sync="searchInputValue"
                  :isDisabled="!filterSearchInvList"
                  :isRequired="filterSearchInvList"
                  :errorMessage.sync="searchInputErrorMessage"
                />
              </div>
            </BoxContainer>
            <button @click="refreshClicked('Main Page')" :disabled="!filterDateInvList && !filterSearchInvList"
              >Refresh
            </button>
          </div>
        </ButtonFilter>
        <div>Last Refreshed: {{ lastRefreshed }}</div>
      </div>
      <div class="bottom-section">
        <TableBox
          :title="pageTitle"
          :tableData="invoiceListing"
          :selectedRow.sync="selectedInvoiceListing"
          :loading="jobTableBoxIsLoading"
        />
      </div>
    </div>
    <PopupEntry
      v-if="popupShow"
      :show.sync="popupShow"
      :title="popupTitle"
      :createdBy="createdBy"
      :updatedBy="updatedBy"
      @save="saveClicked"
      :requiredError="requiredError"
      @requiredClicked="requiredClicked"
      :successMessages="successMessages"
      :errorMessages="errorMessages"
      :viewMode="viewMode"
      :cancelButton="viewMode ? 'Close' : 'Cancel'"
      ref="popup-entry"
      style="display: flex; flex-direction: row; justify-content: space-around; overflow: scroll"
      :canPrint="true"
      @print="popupPrintClicked"
    >
      <div class="ar-entryfields">
        <BoxContainer
          v-if="action != 'N' && !newlyAdd"
          title="Summary of Events"
          :isCollapsible="true"
          :isCollapsed="isCollapsed"
        >
          <div class="summary-row" ref="summary-row">
            <div class="summary-block" v-for="(m, i) in summaryItem" :key="i">
              <Tooltip class="milestone-tooltip" :minWidth="250" :tooltipText="m['Label'].join(',')">
                <div></div>
              </Tooltip>
              <div :id="m['Title']" v-if="m['Title'] != 'PrintCount'" class="summary-item"></div>
              <div
                v-if="m['Title'] == 'PrintCount'"
                class="summary-item"
                :style="{ backgroundColor: `${m['BackColor']}` }"
              >
                {{ arInvoice['PrintCount'] }}
                <img height="20px" :src="m['Src']" />
              </div>
            </div>
          </div>
          <div class="summary-row">
            <div v-for="(l, i) in Object.entries(newLegend)" :key="i" class="legend-items">
              <div class="legend-box" :style="{ backgroundColor: `${l[1]}` }"></div>
              {{ l[0] }}
            </div>
          </div>
        </BoxContainer>
        <BoxContainer class="first-section" style="display: flex; flex-direction: row; margin-top: 12px">
          <div class="left-section" ref="left-section">
            <Dropdown
              :errorMessage.sync="invoiceTypeErr"
              :isRequired="true"
              :placeholder="`${pageTitle} Type`"
              ref="invoicetypeinput"
              :selectedObject.sync="selectedInvoiceTypeList"
              :isDisabled="(viewMode && action != 'N') || selectedInvoiceTypeList != null"
              :items="header['invoiceTypeList']"
              itemKey="Description"
            />
            <InputQuery
              ref="billCustErr"
              :errorMessage.sync="billCustErr"
              placeholder="Billing Customer"
              :isRequired="true"
              :isDisabled="viewMode || invoiceValidity == '2'"
              :items="header['billingCustList']"
              :selectedObject.sync="selectedBillCustomer"
              @selected="selectedBillCustomerIsSelected"
              itemKey="Customer Code"
              descKey="Customer Name"
              validator="text,10"
            />
            <Input
              style="width: 50%"
              placeholder="Job No"
              :inputValue.sync="header['jobno']"
              :isDisabled="viewMode || invoiceValidity == '2'"
              @focusChanged="jobInputChanged"
              validator="text,25"
            />
            <div style="display: flex; flex-direction: row">
              <Dropdown
                :isDisabled="viewMode || invoiceValidity == '2'"
                style="margin-right: 6px"
                placeholder="Credit Type"
                :allowFreeText="false"
                :selectedObject.sync="selectedCreditType"
                :search.sync="header['creditTypeStr']"
                :items="header['creditTypeList']"
                itemKey="Credit Name"
                :errorMessage.sync="creditTypeErr"
                ref="creditTypeErr"
              />
              <Input
                placeholder="Credit Term"
                validator="positiveDecimal,4"
                :inputValue.sync="header['creditTerm']"
                :isDisabled="viewMode || creditTermIsDisabled || invoiceValidity == '2'"
                :errorMessage.sync="creditTermErr"
                ref="creditTermErr"
                @focusChanged="creditTermFocusChanged"
              />
            </div>
          </div>
          <div class="right-section">
            <div class="right-section-top" style="display: flex; flex-direction: row; justify-content: space-around">
              <DateTimePicker
                :showTime="false"
                style="text-wrap: nowrap; margin-right: 5px"
                :placeholder="`${pageTitle} Date`"
                :isDisabled="viewMode || invoiceValidity == '2'"
                :value.sync="header['invoiceDate']"
                :isRequired="true"
                :errorMessage.sync="dataTimeErr"
                ref="dataTimeErr"
              />
              <InputQuery
                style="width: fit-content"
                placeholder="Currency"
                :isRequired="true"
                :tableBoxDataType="tableDataType"
                :items="header['currencyList']"
                :isDisabled="viewMode || invoiceValidity == '2' || newJobChargesDetailsList.length > 0"
                itemKey="Currency Code"
                descKey="Description"
                :selectedObject.sync="headerSelectedCurrency"
                @selected="headerCurrencyFocusChanged"
                ref="currErr"
                :errorMessage.sync="currErr"
                :showDesc="false"
                :allowFreeText="false"
                validator="text,10"
              />
              <Input
                ref="exchErr"
                :errorMessage.sync="exchErr"
                style="text-wrap: nowrap; width: fit-content; margin-right: 5px"
                placeholder="Exch. Rate"
                :isRequired="true"
                :isDisabled="viewMode || invoiceValidity == '2' || disabledHeaderRate"
                textType="number"
                textAlign="right"
                :inputValue.sync="header['exchRate']"
                validator="positiveDecimal,14,4"
                @focusChanged="rateValueChanged"
              />
              <CheckBoxV2
                :isDisabled="viewMode || invoiceValidity == '2'"
                title="Adv. Collection"
                style="text-wrap: nowrap; margin-right: 5px; margin-left: 5px"
                :isChecked.sync="advCollection"
                @checkBoxClicked="advCollectionChecked"
              />
              <CheckBoxV2
                :isDisabled="viewMode || invoiceValidity == '2'"
                title="Final Bill"
                style="text-wrap: nowrap; margin-right: 5px; margin-left: 5px"
                :isChecked.sync="finalBill"
              />
              <Input
                :placeholder="`${pageTitle} No`"
                style="width: fit-content; margin-left: 5px"
                :isDisabled="true"
                :inputValue.sync="header['InvoiceNo']"
              />
            </div>
            <div class="right-section-bottom" style="width: 100%">
              <BoxContainer
                title="Remarks"
                class="box-container-section"
                style="display: flex; width: 100%"
                :isCollapsible="true"
              >
                <div style="display: flex; flex-direction: row; width: 100%">
                  <RemarksBox
                    :text.sync="header['invoiceRem1']"
                    :isDisabled="viewMode || invoiceValidity == '2'"
                    title=""
                    :maxLength="200"
                    style="margin-right: 5px; width: 100%"
                  />
                  <RemarksBox
                    :text.sync="header['invoiceRem2']"
                    :isDisabled="viewMode || invoiceValidity == '2'"
                    title=""
                    :maxLength="200"
                    style="margin-right: 5px; width: 100%"
                  />
                  <RemarksBox
                    :text.sync="header['invoiceRem3']"
                    :isDisabled="viewMode || invoiceValidity == '2'"
                    title=""
                    :maxLength="200"
                    style="margin-right: 5px; width: 100%"
                  />
                </div>
              </BoxContainer>
            </div>
          </div>
        </BoxContainer>
        <div style="height: 100%; margin-top: 10px">
          <Tab
            :preventTabSwitch="true"
            :tabs="tabsItems"
            style="height: 100%"
            :tabIndex.sync="currentTabIndex"
            @tabClicked="tabClicked"
          >
            <!-- Invoice Charges tab -->
            <div :slot="`${pageTitle} Charges`" :style="{ width: '100%', height: '98%', display: 'flex' }">
              <BoxContainer class="table-container" :style="mainInvStyling">
                <div class="tabulator-title">
                  <button v-if="!viewMode || action != ''" @click="openSubPackage()">Select From Job Charges</button>
                  <button v-if="!viewMode || action != ''" @click="openNewJobCharges('add')">Add Charges</button>
                  <button
                    v-if="!viewMode || (action != '' && selectedNewJobChargesDetails.length > 0)"
                    @click="openNewJobCharges('delete')"
                    >Delete Charges</button
                  >
                </div>
                <TableBox
                  title=""
                  :rowHeight="30"
                  v-if="showInvoiceChargesTable"
                  @buttonClicked="editButtonClicked"
                  style="height: 94%; overflow: 'scroll'"
                  :dataType="chargesTableDataType"
                  :additionalButtons="viewMode ? [] : editButtons"
                  :selectedRow.sync="selectedNewJobChargesDetails"
                  :tableData="newJobChargesDetailsList"
                  :hideColumns="[
                    'JobTxnID',
                    'Notes',
                    'AdjType',
                    'InvNo',
                    'TabSource',
                    'finalbilcount',
                    'copy',
                    'orinetamount',
                    '#',
                    'Txnid',
                    'RecordSource',
                  ]"
                />
              </BoxContainer>
              <BoxContainer v-if="openJobCharges" class="table-container" :style="openJobStyling" ref="openJobCharges">
                <div class="tabulator-title" style="display: flex; flex-direction: row; justify-content: space-between">
                  <div style="display: flex; flex-direction: column; justify-content: start">
                    <div>Search Job Charges</div>
                    <div v-if="filterSearch && selectedFilterJobNoConfirm && selectedFilterJobNoConfirmStr != ''"
                      >Filter By Job {{ selectedFilterJobNoConfirmStr }}</div
                    >
                    <div v-if="filterSearch && selectedFilterCngShprConfirm && selectedFilterCngShprConfirmStr != ''"
                      >Filter By Cng/Shpr {{ selectedFilterCngShprConfirmStr }}</div
                    >
                    <div v-if="filterSearch && selectedFilterAreaConfirm && selectedFilterAreaConfirmStr != ''"
                      >Filter By Area {{ selectedFilterAreaConfirmStr }}</div
                    >
                    <div v-if="filterSearch && selectedFilterSendToConfirm && selectedFilterSendToConfirmStr != ''"
                      >Filter By SendTo {{ selectedFilterSendToConfirmStr }}</div
                    >
                    <div v-if="!isUsingJobHeader || filterDate"
                      >From {{ fromDate.formatString('yyyy-MM-dd') }} To {{ toDate.formatString('yyyy-MM-dd') }}</div
                    >
                  </div>
                  <div style="display: flex; justify-content: end">
                    <button
                      style="margin-right: 3px"
                      v-if="selectedSubDetails.length < newSubDetailsList.length"
                      @click="selectAll"
                      >Select All</button
                    >
                    <button style="margin-right: 3px" v-else @click="selectedSubDetails = []">Clear All</button>
                    <button style="margin-right: 3px" v-if="!viewMode" @click="addEditCharges('copy')"
                      >Add Job Charges</button
                    >
                    <ButtonFilter
                      style="margin-right: 3px"
                      class="button-filter-component"
                      filterPosition="right"
                      buttonText="Change Filter"
                      :filterWidth="300"
                      :isOpen.sync="filterIsOpen"
                      :buttonIsDisabled="filterIsDisabled"
                    >
                      <div class="filter-popup">
                        <BoxContainer
                          title="Date"
                          :isCheckBox="true"
                          style="margin-bottom: 12px"
                          :isChecked.sync="filterDate"
                        >
                          <div class="row-display">
                            <DateTimePicker
                              :showTime="false"
                              placeholder="From"
                              :isDisabled="!filterDate"
                              :value.sync="fromDate"
                              :errorMessage.sync="fromDateErrorMessage"
                            />
                            <DateTimePicker
                              :showTime="false"
                              placeholder="To"
                              :isDisabled="!filterDate"
                              :value.sync="toDate"
                              :errorMessage.sync="toDateErrorMessage"
                            />
                          </div>
                        </BoxContainer>
                        <BoxContainer
                          style="margin-bottom: 6px"
                          :isCheckBox="true"
                          :isChecked.sync="filterSearch"
                          @checkBoxClicked="filterSearchIsClicked"
                        >
                          <div style="display: flex; flex-direction: row">
                            <Filters
                              :isDisabled="!filterSearch"
                              style="height: 80px"
                              title="Cng/Shpr"
                              :tableData="cngShpDataList"
                              itemKey="Bill To"
                              @confirmClicked="filterCngShprConfirm"
                              :selectedObject.sync="selectedFilterCngShprConfirm"
                            />
                            <Filters
                              :isDisabled="!filterSearch || isUsingJobHeader"
                              style="height: 80px"
                              title="Job No"
                              :tableData="jobnoList"
                              itemKey="Job No"
                              @confirmClicked="filterJobNoConfirm"
                              :selectedObject.sync="selectedFilterJobNoConfirm"
                            />
                          </div>
                          <div style="display: flex; flex-direction: row">
                            <Filters
                              :isDisabled="!filterSearch"
                              style="height: 80px"
                              title="Area"
                              :tableData="areaDataList"
                              itemKey="Area Code"
                              @confirmClicked="filterAreaConfirm"
                              :selectedObject.sync="selectedFilterAreaConfirm"
                            />
                            <Filters
                              :isDisabled="!filterSearch"
                              style="height: 80px"
                              title="Send To"
                              :tableData="sendToDataList"
                              itemKey="Destination Code"
                              @confirmClicked="filterSendToConfirm"
                              :selectedObject.sync="selectedFilterSendToConfirm"
                            />
                          </div>
                        </BoxContainer>
                        <button @click="refreshClicked('')" :disabled="!filterDate && !filterSearch">Refresh</button>
                      </div>
                    </ButtonFilter>
                    <button v-if="!viewMode" @click="cancelAddNew()">Cancel</button>
                  </div>
                </div>
                <div style="height: 100%">
                  <TableBox
                    v-if="hideSubPackageDetails"
                    :rowHeight="20"
                    :dataType="chargesTableDataType"
                    style="height: 95%"
                    title="Job Charges Details"
                    :maxSelection="-1"
                    :selectedRow.sync="selectedSubDetails"
                    :tableData="newSubDetailsList"
                    :hideColumns="['Txnid', 'copy', '#', 'RecordSource']"
                  />
                </div>
                <!-- <div style="width: 100%; text-align: center; justify-content: center; margin: 6px">

                </div> -->
              </BoxContainer>
              <BoxContainer
                v-if="openAddNew"
                class="table-container"
                :style="openAddNewStyling"
                ref="openAddNewStyling"
              >
                <div class="tabulator-title" style="width: 100%">
                  <div style="width: 50%">
                    <div>{{ addEditChargesTitle }}</div>
                    <InputQuery
                      :isDisabled="viewMode || recordSource"
                      ref="chargesCode"
                      :errorMessage.sync="selectedChargesCodeErr"
                      placeholder="Charges Code"
                      :isRequired="true"
                      :items="chargesCodeList"
                      :selectedObject.sync="selectedChargesCode"
                      itemKey="Charge Code"
                      descKey="Description"
                      @selected="selectedChargesCodeIsSelect"
                      validator="text,10"
                    />
                    <InputQuery
                      :isDisabled="viewMode"
                      placeholder="Group Code"
                      itemKey="Charges Code"
                      descKey="Description"
                      :items="groupCodeList"
                      :selectedObject.sync="selectedGroupCode"
                      :search.sync="freeTextGroupCode"
                      validator="text,10"
                    />
                    <div style="position: relative; display: flex">
                      <div v-if="jobLoading" class="api-loading" name="Job No"></div>
                      <InputQuery
                        :isDisabled="viewMode || recordSource"
                        placeholder="Job No"
                        :showRowLimit="true"
                        :rowLimitInputValue.sync="rowLimitInputValue"
                        itemKey="Job No"
                        :items.sync="jobnoList"
                        :selectedObject.sync="selectedJobno"
                        @selected="jobNoIsSelected"
                        @rowLimitFocusChanged="rowLimitInputValueChanged"
                        validator="text,25"
                      />
                    </div>
                    <InputQuery
                      :isDisabled="viewMode || recordSource"
                      placeholder="Container No"
                      itemKey="Cont No"
                      descKey="Container No"
                      :items="contList"
                      :selectedObject.sync="selectedcontno"
                      validator="text,25"
                    />
                    <InputQuery
                      :isDisabled="viewMode || recordSource"
                      placeholder="Consignment No"
                      itemKey="Consignment No"
                      :items="consignmentList"
                      :selectedObject.sync="selectedCNNO"
                      validator="text,25"
                    />
                  </div>

                  <div style="width: 50%">
                    <div style="display: flex; justify-content: end">
                      <button style="margin-right: 3px" v-if="!viewMode" @click="addEditCharges()">{{
                        selectedNewJobChargesDetails.length === 0 ? 'Add' : 'Edit'
                      }}</button>
                      <button v-if="!viewMode || action == ''" @click="cancelAddNew()">Cancel</button>
                    </div>
                    <RemarksBox :isDisabled="viewMode" :maxLength="100" title="Description" :text.sync="invoiceDesc" />
                    <InputQuery
                      :isDisabled="viewMode"
                      placeholder="Cost Code"
                      itemKey="Cost Code"
                      descKey="Cost Desc"
                      :items="costCodeList"
                      :selectedObject.sync="selectedCostCode"
                      validator="text,10"
                    />
                    <InputQuery
                      :isDisabled="viewMode"
                      placeholder="Adjustment Type"
                      itemKey="Type"
                      :items="adjustmentType"
                      :selectedObject.sync="selectedAdjustment"
                      validator="text,25"
                    />
                    <Input
                      v-if="pageType == 'Debit'"
                      validator="text,200"
                      :isDisabled="viewMode"
                      placeholder="Invoice Ref No"
                      :inputValue.sync="invRefNo"
                    />
                  </div>
                </div>
                <ForeignCurrency
                  :action="action"
                  :selectedChargesCode.sync="selectedChargesCode"
                  :payableChecking="payableChecking"
                  :enableTaxSection="true"
                  :taxCodeRate.sync="taxCodeRate"
                  :recordSource.sync="recordSource"
                  :internalCustomer.sync="internalCustomer"
                  :details.sync="foreignDetails"
                  :viewMode="viewMode"
                  ref="foreignCurrency"
                  :headerCurrency.sync="headerSelectedCurrency"
                  :headerRate.sync="header['exchRate']"
                  :allowNegativeAmt="true"
                >
                  <div slot="buying-first-col">
                    <Dropdown
                      placeholder="Payee Type"
                      :isRequired="selectedJobno !== null"
                      :items="payeeTypeList"
                      :isDisabled="viewMode || recordSource || !selectedJobno"
                      itemKey="Party"
                      :selectedObject.sync="selectedPayeeType"
                      @selected="payeeTypeSelected"
                      :errorMessage.sync="payeeTypeError"
                    />
                  </div>
                  <div slot="buying-second-col">
                    <InputQuery
                      placeholder="Payee Code"
                      :isRequired="selectedJobno !== null"
                      :items="payeeCodeList"
                      :isDisabled="viewMode || recordSource || !selectedJobno"
                      :itemKey="payeeCodeKey"
                      :descKey="payeeCodeDesc"
                      :selectedObject.sync="selectedPayeeCode"
                      :errorMessage.sync="payeeCodeError"
                      validator="text,10"
                    />
                  </div>
                  <div class="foreign-currency-style" slot="buying-third-col"></div>
                </ForeignCurrency>
                <div style="display: flex; flex-direction: column; width: 100%; padding-top: 6px">
                  <button
                    style="width: 200px; display: flex; justify-content: end"
                    v-if="!viewMode"
                    @click="copyStatus()"
                    >Copy Job Status Details</button
                  >
                  <RemarksBox
                    ref="itemNote"
                    :errorMessage.sync="itemNoteErr"
                    :freeText="false"
                    :maxLength="2000"
                    :text.sync="itemNote"
                    :isDisabled="viewMode"
                    style="width: 100%"
                    title="Item Notes"
                  />
                </div>
              </BoxContainer>
            </div>
            <!-- Additional Info tab -->
            <div slot="Additional Info" style="height: 100%; width: 100%; overflow: scroll">
              <div style="width: 100%">
                <div style="display: flex; flex-direction: row; width: 100%; margin-bottom: 13px">
                  <BoxContainer title="Delivery Details" style="width: 50%; margin-right: 4px" :isCollapsible="true">
                    <Input
                      :inputValue.sync="companyName"
                      validator="text,40"
                      :isDisabled="viewMode"
                      :errorMessage.sync="companyNameErr"
                      placeholder="Company Name"
                    />
                    <div style="display: flex; flex-direction: row">
                      <Input
                        :inputValue.sync="companyTIN"
                        :isDisabled="viewMode"
                        style="margin-right: 3px"
                        :errorMessage.sync="companyTinErr"
                        placeholder="Company TIN"
                        validator="alphanumeric,13,"
                      />
                      <Input
                        :inputValue.sync="companyRegNo"
                        :isDisabled="viewMode"
                        placeholder="Company Reg. No."
                        :errorMessage.sync="companyRegNoErr"
                        validator="alphanumeric,12,"
                      />
                    </div>
                    <AddressFormV2
                      :address.sync="defaultAddressData"
                      :viewMode="viewMode"
                      :postcodes="postcodeList"
                      :states="stateList"
                      :countries="countryList"
                      :addressErrors.sync="addressErrors"
                      ref="addressForm"
                    />
                  </BoxContainer>
                  <BoxContainer
                    title="Report Header Description"
                    :isCheckBox="true"
                    @checkBoxClicked="rptHdrChange"
                    :checkBoxIsDisabled="viewMode || (selectedJobInfo && jobList.length == 1)"
                    :isChecked.sync="reportHdrCheck"
                    style="width: 50%"
                    :isCollapsible="true"
                  >
                    <div
                      v-if="!showInfoFromJob && !showFromTemplate && reportHdrCheck && !selectedHeaderDesc"
                      style="color: red"
                      >Please select any of the Header Description selection below.</div
                    >
                    <div style="display: flex; flex-direction: row; margin: 3px">
                      <RadioButtonSet
                        labelKey="label"
                        :isDisabled="viewMode"
                        name="header"
                        @radioChanged="radioChanged"
                        style="margin-top: 5px"
                        :isHorizontal="true"
                        title=""
                        :selected.sync="selectedHeaderDesc"
                        :buttons="headerDescRadioButtons"
                      />
                    </div>
                    <div style="display: flex; flex-direction: row; margin: 3px" v-if="showInfoFromJob">
                      <InputQuery
                        :isDisabled="viewMode || (selectedJobInfo && jobList.length == 1)"
                        style="width: 400px; margin-top: 6px"
                        placeholder="Job"
                        :items="jobList"
                        itemKey="JobNo"
                        :selectedObject.sync="selectedJobInfo"
                        :showDesc="false"
                        validator="text,25"
                      />
                      <Tooltip
                        class="milestone-tooltip"
                        tooltipText="Please make sure any of the Details have Job No"
                      />
                    </div>
                    <div v-if="showFromTemplate" style="display: flex; flex-direction: row; margin: 6px; height: 100%">
                      <RemarksBox
                        :isDisabled="viewMode"
                        style="height: 120px; margin-right: 3px"
                        :freeText="true"
                        title="Left side"
                        :text.sync="leftSideText"
                      />
                      <RemarksBox
                        :isDisabled="viewMode"
                        style="height: 120px"
                        :freeText="true"
                        title="Right side"
                        :text.sync="rightSideText"
                      />
                    </div>
                  </BoxContainer>
                </div>
                <BoxContainer
                  style="display: flex; flex-direction: column; width: 100%; height: 100%"
                  title="Report Job Info"
                  :isCollapsible="true"
                >
                  <div style="display: flex; flex-direction: row">
                    <div style="width: 50%; margin-right: 6px">
                      <Input
                        validator="positiveDecimal,11,4"
                        :inputValue.sync="gweight"
                        type="number"
                        :errorMessage.sync="gweightErrMessage"
                        ref="gweightErrMessage"
                        :isDisabled="viewMode"
                        style="margin-right: 5px"
                        placeholder="GWeight"
                      />
                      <Input
                        validator="positiveDecimal,11,4"
                        :inputValue.sync="measurement"
                        :isDisabled="viewMode"
                        :errorMessage.sync="measurementErrMessage"
                        ref="measurementErrMessage"
                        placeholder="Measurement"
                      />
                    </div>
                    <div style="width: 50%">
                      <RemarksBox
                        :text.sync="commodity"
                        :errorMessage.sync="commodityErr"
                        :isDisabled="viewMode"
                        :maxLength="254"
                        style="height: fit-content"
                        title="Commodity"
                      />
                      <CheckBoxV2
                        :isChecked.sync="updateJob"
                        :isDisabled="viewMode"
                        style="width: fit-content; text-wrap: nowrap; margin-left: 6px"
                        title="Update Job (Gweight, Measurement ONLY)"
                      />
                      <!-- <dir style="height: fit-content; width: 100%; margin: 0; display: content">Select Container that you want to show in invoice report.</dir>
                      <Filters style="height: 90%" title="Container No"></Filters> -->
                    </div>
                  </div>
                </BoxContainer>
              </div>
            </div>
            <!-- Payment tab -->
            <div slot="Payment" style="height: 100%; width: 100%; overflow: scroll">
              <Dropdown
                :items="paymentModelist"
                :selectedObject.sync="selectedPaymentlist"
                :isDisabled="viewMode"
                style="width: 30%"
                placeholder="Payment Mode"
              />
              <Dropdown
                :items="bankCodeList"
                :selectedObject.sync="selectedBankCode"
                :isDisabled="viewMode"
                style="width: 30%"
                placeholder="Bank Code"
              />
              <DateTimePicker
                :isDisabled="viewMode"
                :showTime="false"
                style="text-wrap: nowrap; width: 30%"
                placeholder="Payment Date"
                :value.sync="paymentDate"
              />
              <Dropdown
                :items="paymentRefNoList"
                :selectedObject.sync="selectedPaymentRefNo"
                :isDisabled="viewMode"
                style="width: 30%"
                placeholder="Payment Ref No"
              />
            </div>
            <!-- Attachment tab -->
            <div slot="Attachment" style="height: 95%; width: 100%; overflow: scroll">
              <div
                style="display: flex; justify-content: end; margin-bottom: 6px; min-height: fit-content; height: 10%"
              >
                <button
                  style="height: fit-content; margin-right: 6px"
                  v-if="!viewMode"
                  @click="attachmentBtnClicked('add')"
                  >Add Attachments</button
                >
                <button
                  style="height: fit-content; margin-right: 6px"
                  v-if="!viewMode || documentsList.Length > 0"
                  @click="attachmentBtnClicked('edit')"
                  >Edit Attachments</button
                >
                <button style="height: fit-content" v-if="!viewMode || documentsList.Length > 0" @click="deleteDocument"
                  >Del Attachments</button
                >
              </div>
              <TableBox
                style="height: 85%"
                :rowHeight="30"
                title="Attachment"
                @buttonClicked="attEditButtonClicked"
                :stickColumn="[0]"
                :additionalButtons="[{ text: 'View', index: 0, width: 80 }]"
                :tableData="documentsList"
                :dataType="docDataType"
                :selectedRow.sync="selectedDoc"
                :hideColumns="[
                  'Action',
                  'Doc Image',
                  'Sequence No',
                  'Document GUID',
                  'ID',
                  'Doc Ref No',
                  'Job No',
                  'Doc Code',
                  'Doc Type',
                  'Doc Rec Date',
                  'Doc Rec Time',
                  '_attachmentAction',
                ]"
              />
            </div>
            <!-- Events tab -->
            <div style="height: 95%; overflow: scroll" slot="Events">
              <div style="height: 100%">
                <div style="display: flex; flex-direction: row; width: 100%; height: 15%" ref="salesSection">
                  <BoxContainer
                    title="Show Details"
                    style="width: 50%; display: flex; flex-direction: row; margin-right: 3px"
                  >
                    <CheckBoxV2
                      :isChecked.sync="showGLEntry"
                      :isDisabled="false"
                      style="width: fit-content; text-wrap: nowrap; margin-left: 6px"
                      title="GL Entry"
                    />
                    <CheckBoxV2
                      :isChecked.sync="showOffset"
                      :isDisabled="false"
                      style="width: fit-content; text-wrap: nowrap; margin-left: 6px"
                      title="Offset Documents"
                    />
                    <CheckBoxV2
                      :isChecked.sync="showeInvoice"
                      :isDisabled="false"
                      style="width: fit-content; text-wrap: nowrap; margin-left: 6px"
                      title="eInvoice Submission"
                    />
                  </BoxContainer>
                  <BoxContainer
                    v-if="false"
                    title="IRBM Details"
                    style="width: 50%; display: flex; flex-direction: row; margin-right: 3px"
                  >
                    <Input :isDisabled="viewMode" placeholder="IRBM Ref No" />
                    <Input :isDisabled="viewMode" placeholder="IRBM Validation Date and Time" />
                    <Input :isDisabled="viewMode" :placeholder="`IRBM Original ${pageTitle} No`" />
                  </BoxContainer>
                  <BoxContainer title="Sales Person" style="width: 50%; display: flex; flex-direction: row">
                    <InputQuery
                      descKey="Sales Team Name"
                      itemKey="Sales Team Code"
                      :items="salesTeamList"
                      :selectedObject="selectedSalesTeamList"
                      :isDisabled="true"
                      style="margin-right: 10px"
                      placeholder="Sales Team"
                      validator="text,50"
                    />
                    <InputQuery
                      descKey="Sales Person Name"
                      itemKey="Sales Person Code"
                      :items="salesPersonList"
                      :selectedObject="selectedSalesPersonList"
                      :isDisabled="true"
                      placeholder="Sales Person"
                      validator="text,60"
                    />
                  </BoxContainer>
                </div>
                <div style="height: 85%; width: 100%; display: flex; flex-direction: row">
                  <BoxContainer v-if="showGLEntry" :style="glEntryStyling" title="GL Entry">
                    <TableBox
                      title=""
                      :rowHeight="20"
                      style="height: 100%"
                      :tableData="glEntry"
                      :dataType="glDataType"
                    />
                    <div style="display: flex; flex-direction: row; justify-content: space-around; margin-top: 6px">
                      <div style="display: flex; flex-direction: row">
                        <div style="align-self: center; width: 100px">TOTAL DEBIT</div>
                        <div class="total-block">{{ totalDebit }}</div>
                      </div>
                      <div style="display: flex; flex-direction: row">
                        <div style="align-self: center; width: 100px">TOTAL CREDIT</div>
                        <div class="total-block">{{ totalCredit }}</div>
                      </div>
                    </div>
                  </BoxContainer>
                  <BoxContainer :style="offsetStyling" v-if="showOffset" title="Offset Documents">
                    <TableBox
                      title=""
                      :rowHeight="20"
                      style="height: 100%"
                      :tableData="arInvoice['Offset']"
                      :hideColumns="['TxnDet']"
                    />
                  </BoxContainer>
                  <BoxContainer v-if="showeInvoice" :style="eInvoiceStyling" title="LHDN Submission">
                    <TableBox
                      title=""
                      :rowHeight="20"
                      style="height: 100%"
                      :tableData="eInvoiceList"
                      :hideColumns="['#']"
                    />
                  </BoxContainer>
                </div>
              </div>
            </div>
          </Tab>
        </div>
      </div>
      <BoxContainer>
        <div style="display: flex; flex-direction: row; justify-content: flex-end">
          <div style="display: flex; margin-right: 20px">
            <div style="align-content: center; margin-right: 10px; font-size: 1.1em">{{
              `TOTAL ${pageTitle.toUpperCase()} AMT`
            }}</div>
            <div style="display: flex">
              <div
                class="total-block"
                style="font-size: 1.1em; text-align: right; display: inline; padding-right: 5px"
                >{{
                  multiCurr ? 'N/A' : (
                    `${headerSelectedCurrency ? headerSelectedCurrency['Currency Code'] : 'MYR'} ${ftotalAmt ? ftotalAmt : '0'}`
                  )
                }}</div
              >
              <div
                class="total-block"
                style="
                  background-color: #467cdc;
                  color: white;
                  font-size: 1.1em;
                  font-weight: bold;
                  text-align: right;
                  display: inline;
                  padding-right: 5px;
                "
                >MYR {{ totalAmt ? totalAmt : '0' }}</div
              >
            </div>
          </div>
          <div style="display: flex">
            <div style="align-content: center; margin-right: 10px; font-size: 1.1em">OUTSTANDING AMT</div>
            <div style="display: flex">
              <div
                class="total-block"
                style="font-size: 1.1em; text-align: right; display: inline; padding-right: 5px"
                >{{
                  multiCurr ? 'N/A' : (
                    `${headerSelectedCurrency ? headerSelectedCurrency['Currency Code'] : 'MYR'} ${foutstandingAmt ? foutstandingAmt : '0'}`
                  )
                }}</div
              >
              <div
                class="total-block"
                style="
                  background-color: #467cdc;
                  color: white;
                  font-size: 1.1em;
                  font-weight: bold;
                  text-align: right;
                  display: inline;
                  padding-right: 5px;
                "
                >MYR {{ outstandingAmt ? outstandingAmt : '0' }}</div
              >
            </div>
          </div>
        </div>
      </BoxContainer>
    </PopupEntry>
    <PopupV2
      :show="showDeleteInvoicePopupWithRemarks"
      :title="`Delete ${pageTitle}`"
      @buttonClicked="deletePopupClicked"
      :buttons="deletePopupButtons"
    >
      <div
        >Please state reason to delete
        {{ selectedInvoiceListing.length > 0 ? selectedInvoiceListing[0]['Invoice #'] : '' }}?</div
      >
      <Input
        placeholder="Delete Remarks"
        :inputValue.sync="deleteInvoiceRemarks"
        :errorMessage.sync="deleteInvoiceErr"
        :isRequired="true"
      />
    </PopupV2>
    <PopupV2
      width="600px"
      style="height: 100%; width: 100%; overflow: visible"
      :show="showJobStatusList"
      title="Job Status Details"
      @buttonClicked="JobStatusPopupClicked"
      :buttons="showJobStatusButtons"
    >
      <TableBox
        :rowHeight="20"
        :columnWidth="[50, 200, 200]"
        style="height: 100%; width: 100%"
        title="Job Status Details"
        :maxSelection="1"
        :selectedRow.sync="selectedStatusListCategory"
        :tableData="statusListCategory"
      />
    </PopupV2>
    <PopupV2
      :show.sync="showUpdateDocType"
      :title="`Update ${pageTitle} Type`"
      :buttons="updatePopupButtons"
      @buttonClicked="updateDocTypePopupClicked"
      height="450px"
    >
      <div class="updateDocTypeBody">
        <Dropdown
          :placeholder="`${pageTitle} Type`"
          :isRequired="true"
          :items="header['invoiceTypeList']"
          itemKey="Description"
          :selectedObject.sync="selectedUpdatedInvoiceTypeList"
          :errorMessage.sync="selectedUpdatedInvoiceTypeListErrMessage"
        />
      </div>
    </PopupV2>
    <div class="attachments-popup-container">
      <PopupV2
        class="attachments-popup"
        :show="showAttachmentsPopup"
        :title="attachmentsPopupTitle"
        :buttons="attachmentsPopupButtons"
        @buttonClicked="addDocument"
      >
        <div class="attachments-popup-content">
          <Input
            textType="file"
            placeholder="Select File"
            ref="docFile"
            :isDisabled="viewMode"
            :inputValue.sync="documents['docName']"
            @fileChanged="handleFileUpload"
          />
          <div v-if="docEditMode">
            <div> Attachment: {{ documents['docName'] }} </div>
          </div>
          <div v-if="attachmentsAction == 'edit'" class="attached-file">
            <strong>Attached file: </strong>
            <span>
              {{ selectedDoc.length > 0 ? selectedDoc[0]['File Name'] : '' }}
            </span>
          </div>
          <RemarksBox
            :maxLength="200"
            style="height: 50%"
            title="Remarks"
            :isDisabled="viewMode"
            :text.sync="documents['remarks']"
          />
        </div>
      </PopupV2>
    </div>
    <div v-if="showAttachmentProjector" class="attachment-projector">
      <div class="attachment-projection">
        <object
          v-if="isProjectable"
          :data="attachmentProjectorData"
          :type="attachmentProjectorType"
          draggable="false"
        ></object>
        <div v-else class="attachment-not-projectable-container">
          <span>
            {{ selectedDoc[0]['File Type'].replace('.', '').toUpperCase() }} files cannot be previewed.<br />
            Please download the file and view it instead.
          </span>
          <button @click="downloadAttachment">
            <img src="https://dsmlib.logistics.systems/Icons/Download.png" alt="Download icon" />
            Download
          </button>
        </div>
      </div>
      <div class="close-button" @click="closeProjector"> &times; </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {
    glEntryStyling: function () {
      return {
        height: 'maxContent',
        width: this.showDetailsChecking,
        display: 'flex',
        marginRight: '3px',
        marginTop: '12px',
        flexDirection: 'column',
      };
    },
    offsetStyling: function () {
      return {
        height: 'maxContent',
        width: this.showDetailsChecking,
        display: 'flex',
        marginRight: '3px',
        marginTop: '12px',
        flexDirection: 'column',
      };
    },
    eInvoiceStyling: function () {
      return {
        height: 'maxContent',
        width: this.showDetailsChecking,
        display: 'flex',
        marginRight: '3px',
        marginTop: '12px',
        flexDirection: 'column',
      };
    },
    showDetailsChecking: function () {
      if (
        (!this.showGLEntry && this.showOffset && this.showeInvoice) ||
        (this.showGLEntry && !this.showOffset && this.showeInvoice) ||
        (this.showGLEntry && this.showOffset && !this.showeInvoice)
      ) {
        return '50%';
      } else if (
        (!this.showGLEntry && !this.showOffset && this.showeInvoice) ||
        (!this.showGLEntry && this.showOffset && !this.showeInvoice) ||
        (this.showGLEntry && !this.showOffset && !this.showeInvoice)
      ) {
        return '100%';
      } else if (this.showGLEntry && this.showOffset && this.showeInvoice) {
        return '33.33%';
      }
      return '100%';
    },
    totalDebit: function () {
      let temp = 0.0;
      if (this.glEntry.length > 0) {
        this.glEntry.forEach((gld) => {
          if (gld['Debit Ac'] != '0') {
            temp = parseFloat(temp) + parseFloat(gld['Amount']);
          }
        });
      }
      return this.$currencyFormat(temp);
    },
    totalCredit: function () {
      let temp = 0.0;
      if (this.glEntry.length > 0) {
        this.glEntry.forEach((gld) => {
          if (gld['Credit Ac'] != '0') {
            temp = parseFloat(temp) + parseFloat(gld['Amount']);
          }
        });
      }
      return this.$currencyFormat(temp);
    },
    openAddNewStyling: function () {
      return {
        width: this.openAddNew ? '50%' : '0%',
        height: '100%',
        overflow: 'scroll',
      };
    },
    openJobStyling: function () {
      return {
        width: this.openJobCharges ? '50%' : '0%',
        height: '100%',
      };
    },
    mainInvStyling: function () {
      return {
        width: this.openJobCharges || this.openAddNew ? '50%' : '100%',
        marginRight: '3px',
        height: '100%',
      };
    },
    // eventTablesHeightStyling: function(){
    //   return {
    //     width: (this.openJobCharges || this.openAddNew) ? '50%' : '100%',
    //     marginRight: '3px',
    //     height: `${100% - '20px'}`,
    //     display: 'flex',
    //     flexDirection: 'row'
    //   };
    // },
    disabledHeaderRate: function () {
      if (!this.headerSelectedCurrency) {
        return false;
        // eslint-disable-next-line no-else-return -- easier to read code
      } else {
        return (
          this.headerSelectedCurrency['Currency Code'] == 'MYR' &&
          this.header['exchRate'] == Number(this.headerSelectedCurrency['Currency Rate']).toFixed(4).toString()
        );
      }
    },
  },
  data: function () {
    return {
      // #region Main
      pageType: '',
      oldRate: '',
      pageTitle: '',
      newlyAdd: false,
      menu: [
        {
          title: 'New',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-add-new-50.png',
          enabled: false,
          key: 'mnuNew',
        },
        {
          title: 'Edit',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          enabled: false,
          key: 'mnuEdit',
        },
        {
          title: 'Delete',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-reduce-50.png',
          enabled: false,
          key: 'mnuDelete',
        },
        {
          title: 'View',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png',
          enabled: false,
          key: 'mnFind',
        },
        // { title: 'Copy Current', icon: 'https://dsmlib.logistics.systems/Icons/copy-80px.png', enabled: false },
        { title: 'Print', icon: 'https://dsmlib.logistics.systems/Icons/Print.png', enabled: false, key: 'mnuInvoice' },
        // { title: 'Export to CSV File', icon: 'https://img.icons8.com/office/80/000000/csv.png', enabled: false },
        { title: 'Import Data', icon: 'https://dsmlib.logistics.systems/Icons/icons8-view-64.png', enabled: false },
        // { title: 'Action', icon: 'https://dsmlib.logistics.systems/Icons/Print.png', enabled: false },
        {
          title: 'Update Doc Type',
          icon: 'https://dsmlib.logistics.systems/Icons/icons8-edit-64%20(1).png',
          enabled: false,
          key: 'mnuUpInvType',
        },
        {
          title: 'Authorize',
          icon: 'https://dsmlib.logistics.systems/Icons/Approve.png',
          enabled: false,
          visible: false,
          key: 'mnAuthorized',
        },
        {
          title: 'Unauthorize',
          icon: 'https://dsmlib.logistics.systems/Icons/Approve.png',
          enabled: false,
          visible: false,
          key: 'mnUnAuthorized',
        },
      ],
      currentTabIndex: 0,
      tabsItems: [
        { title: 'Charges', disabled: false },
        { title: 'Additional Info', disabled: false },
        // { title: 'Payment', disabled: false }, // hide first
        { title: 'Attachment', disabled: false },
        { title: 'Events', disabled: false }, // hide IRBM section
      ],
      // GSTEnabled: false,
      lastRefreshed: '',
      // jobData: [],
      // selectedJob: [],
      jobTableBoxIsLoading: false,
      createdBy: '',
      updatedBy: '',
      popupTitle: '',
      totalAmt: '',
      ftotalAmt: '',
      outstandingAmt: '',
      foutstandingAmt: '',
      totalInWords: '',
      popupShow: false,
      requiredError: [],
      successMessages: [],
      errorMessages: [],
      viewMode: false,
      isCollapsed: false,
      dataTimeErr: '',
      filterDate: false,
      filterSearch: false,
      mainFilterIsDisabled: false,
      taxCodeRate: null,
      filterIsDisabled: false,
      summaryItem: [
        {
          Title: 'Indicator',
          Label: ['New', 'Cancelled', 'Printed', 'Month End'],
          Indicator: [
            { code: 'N', name: 'New Invoice', bg: '#79d279' },
            { code: 'C', name: 'Cancelled', bg: 'FFFFFF' },
            { code: 'P', name: 'Printed', bg: '#79d279' },
            { code: 'M', name: 'Month End', bg: 'FFFFFF' },
          ],
        },
        {
          Title: 'Authorized',
          Label: ['Authorized', 'Unauthorize'],
          Indicator: [
            { code: 'A', name: 'Authorized', bg: '#79d279' },
            { code: 'U', name: 'Unauthorize', bg: '#ffff99' },
          ],
        },
        {
          Title: 'LHDN Submission',
          Label: ['LHDN Queue', 'LHDN Sent', 'LHDN Accepted', 'LHDN Rejected', 'LHDN Cancelled', 'LHDN Pending'],
          Indicator: [
            { code: 'Q', name: 'LHDN Queue', bg: '#ffff99' },
            { code: 'S', name: 'LHDN Sent', bg: '#ffff99' },
            { code: 'A', name: 'LHDN Accepted', bg: '#79d279' },
            { code: 'R', name: 'LHDN Rejected', bg: '#ff8787' },
            { code: 'C', name: 'LHDN Cancelled', bg: 'FFFFFF' },
            { code: 'P', name: 'LHDN Pending', bg: '#ffff99' },
          ],
        },
        {
          Title: 'PrintCount',
          Src: 'https://dsmlib.logistics.systems/Icons/Print.png',
          Label: ['Print Count'],
          Indicator: [{ code: '0', name: 'Print Count' }],
        },
      ],
      errorTabMapping: [
        { key: 'companyNameErr', tab: 1 },
        { key: 'commodityErr', tab: 1 },
        { key: 'companyTinErr', tab: 1 },
        { key: 'companyRegNoErr', tab: 1 },
        { key: 'gweightErrMessage', tab: 1 },
        { key: 'measurementErrMessage', tab: 1 },
      ],
      newLegend: {
        // eslint-disable-next-line vue/no-unused-properties -- is being used but it used the index instead of the name
        Completed: '#79d279',
        // eslint-disable-next-line vue/no-unused-properties -- is being used but it used the index instead of the name
        Pending: '#ffff99',
      },
      showDeleteInvoicePopupWithRemarks: false,
      deleteInvoiceRemarks: '',
      deleteInvoiceErr: '',
      deletePopupButtons: [
        { text: 'Delete', color: 'red', textColor: 'white' },
        { text: 'Cancel', color: 'lightgray', textColor: 'black' },
      ],
      openJobCharges: false,
      jobLoading: true,
      openAddNew: false,
      addEditChargesTitle: 'New Job Charges',
      selectedInvoiceTypeList: null,
      invoiceTypeErr: '',
      advCollection: false,
      currErr: '',
      billCustErr: '',
      exchErr: '',
      headerSelectedCurrency: null,
      arInvoice: [],
      oldCurrency: null,
      selectedBillCustomer: null,
      internalCustomer: '0', //0 is not internal
      // exemptionTaxRate: '0',
      // exemptionTaxCode: '',
      // defaultRate: '0',
      // defaultCode: '',
      tableDataType: {
        // available data type string, number, date, currency
        '#': 'number',
        'Currency Code': 'string',
        Description: 'string',
        'Currency Rate': 'currency',
        'Exchange Date': 'date',
        Factor: 'number',
      },
      chargesTableDataType: {
        '#': 'number',
        'Buying Amount': 'currency',
        'Mark Up Amount': 'currency',
        'Srv Tax Amount': 'currency',
        'Selling Amount': 'currency',
        'Buying Famount': 'currency',
        'Mark Up FAmount': 'currency',
        'Srv Tax FAmount': 'currency',
        'Selling FAmount': 'currency',
        'Selling Rate': 'rate',
        'Srv Tax Rate': 'currency',
        Qty: 'number',
        'Selling Unit Price': 'currency',
        'Selling FUnit Price': 'currency',
        DateUpdated: 'date',
        'Tax Amt': 'currency',
        'Tax FAmount': 'currency',
        'Tax Rate': 'currency',
        'Buying Rate': 'rate',
        'Selling FTotal': 'currency',
        'Selling Total': 'currency',
        'Ori Net Amount': 'currency',
        orinetamount: 'currency',
        'Buying Unit Price': 'currency',
        'Markup Unit Price': 'currency',
        'FBuying Unit Price': 'currency',
        'FMark Up Unit Price': 'currency',
        'Job Date': 'date',
        ContSize: 'number',
      },
      glDataType: {
        Amount: 'currency',
      },
      selectedHeaderDesc: null,
      header: {
        currencyList: [],
        billingCustList: [],
        invoiceTypeList: [],
        // billingCust: '',
        creditTypeList: [],
        creditTypeStr: '',
        creditTerm: '',
        jobno: '',
        invoiceDate: new Date(),
        InvoiceNo: '',
        invoiceRem1: '',
        invoiceRem2: '',
        invoiceRem3: '',
        exchRate: '',
        currFactor: '',
      },
      userid: '',
      glEntry: [],
      eInvoiceList: [],
      showGLEntry: true,
      showOffset: false,
      showeInvoice: false,
      finalBill: true,
      selectedCreditType: null,
      // creditTermValidator: '',
      creditTermIsDisabled: false,
      jobtypeid: '',
      multiCurr: false,
      // #endregion

      // #region Invoice Charges data
      payeeCodeError: '',
      payeeTypeError: '',
      showJobStatusList: false,
      rowLimitInputValue: '1000',
      statusListCategory: [],
      selectedStatusListCategory: [],
      showInvoiceChargesTable: true,
      // deletedJobChargesList: [],
      editButtons: [{ text: 'Edit', index: 0, width: 80 }],
      showJobStatusButtons: [
        { text: 'OK', index: 0, width: 60 },
        { text: 'Cancel', index: 1, width: 80 },
      ],
      payeeTypeList: [],
      selectedPayeeType: null,
      selectedPayeeCode: null,
      payeeCodeList: [],
      payeeCodeKey: '',
      payeeCodeDesc: '',
      // isLoadingJob: false,
      invoiceValidity: '0',
      payableChecking: '1',
      selectedSubDetails: [],
      newSubDetailsList: [],
      tempNewSubDetailsList: [],
      newJobChargesDetailsList: [],
      deletedNewJobChargesDetailsList: [],
      selectedNewJobChargesDetails: [],
      // jobChargesData: [],
      chargesCodeList: [],
      selectedChargesCode: null,
      selectedChargesCodeErr: '',
      groupCodeList: [],
      selectedGroupCode: null,
      freeTextGroupCode: '',
      jobnoList: [],
      selectedJobno: null,
      contList: [],
      selectedcontno: null,
      invoiceDesc: '',
      costCodeList: [],
      consignmentList: [],
      selectedCNNO: null,
      selectedCostCode: null,
      invRefNo: '',
      itemNote: '',
      itemNoteErr: '',
      fromDate: new Date(),
      toDate: new Date(),
      fromDateErrorMessage: '',
      toDateErrorMessage: '',
      invoiceListing: [],
      selectedInvoiceListing: [],
      fromInvoiceListingDate: new Date(),
      fromInvoiceListingDateErr: '',
      toInvoiceListingDate: new Date(),
      toInvoiceListingDateErr: '',
      filterDateInvList: true,
      SASEnableTaxCode: true,
      SASEnableTaxRate: true,
      filterSearchInvList: false,
      searchByValue: null,
      searchByErrorMessage: '',
      searchFilterItems: [{ 'Search By': 'Invoice #', key: 'IN' }],
      searchCriteriaItems: [{ name: 'EQUALS' }, { name: 'STARTS WITH' }, { name: 'CONTAINS' }, { name: 'ENDS WITH' }],
      selectedFilterSearchCriteria: null,
      searchCriteriaErrorMessage: '',
      searchInputValue: '',
      searchInputErrorMessage: '',
      headerDescRadioButtons: [
        { label: 'Show info from Job', keyValue: '1' },
        { label: 'Show info from template', keyValue: '0' },
      ],
      adjustmentType: [
        { '#': 1, Type: 'Adjustment', Code: 'A' },
        { '#': 2, Type: 'Rebate', Code: 'D' },
      ],
      recordSource: false,
      selectedAdjustment: null,
      filterText: '',
      action: '',
      mainFilterIsOpen: false,
      filterIsOpen: false,
      foreignDetails: {
        //save api key //get api key
        quantity: '', //qty //Qty
        uom: '', //uom //UOM
        buying: {
          currency: '', //buyingcurrency //Buying Currency
          unitPrice: '',
          totalPrice: '', //fbuying //Buying Famount
          exchRate: '', //buyingrate //Buying Rate
        },
        markup: {
          unitPrice: '',
          totalPrice: '', // fmarkup //Mark Up FAmount
        },
        selling: {
          currency: '', // sellingcurrency //Currency
          unitPrice: '', // fsellingunitprice //Selling FUnit Price
          totalPrice: '', // fsellingtotal //Selling FTotal
          exchRate: '', // sellingrate //Selling Rate
        },
        myrEquivalent: {
          buyingUnitPrice: '',
          buyingTotalPrice: '', //buying //Buying Amount
          markupUnitPrice: '',
          markupTotalPrice: '', //markup //Mark Up Amount
          sellingUnitPrice: '', //sellingunitprice //Selling Unit Price
          sellingTotalPrice: '', //sellingtotal //Selling Total
        },
        tax: {
          gsttaxCode: '', //gsttaxcode //Tax Code
          taxRate: '', //gsttaxrate //Tax Rate
          taxAmt: '', //gsttaxableamt //Tax Famt
          ftaxAmt: '', //gstftaxableamt //Tax FAmount

          sstTaxCode: '', //gsttaxcode //Tax Code
          srvTaxRate: '', //servicetax //Srv Tax Rate
          netInclTax: '', //selling //Selling Amount
          fnetInclTax: '', //fselling //Selling FAmount
          srvTaxAmt: '', //taxableamt //Srv Tax Amount
          fsrvTaxAmt: '', //ftaxableamt //Srv Tax FAmount
        },
      },
      chargesDetailsIndex: -1,
      areaDataList: [],
      selectedFilterCngShprConfirm: [],
      selectedFilterCngShprConfirmStr: '',
      selectedFilterJobNoConfirm: [],
      selectedFilterJobNoConfirmStr: '',
      selectedFilterAreaConfirm: [],
      selectedFilterAreaConfirmStr: '',
      selectedFilterSendToConfirm: [],
      selectedFilterSendToConfirmStr: '',
      cngShpDataList: [],
      sendToDataList: [],
      hideSubPackageDetails: true,
      isUsingJobHeader: false,
      // #endregion

      // #region Addtional data
      companyNameErr: '',
      commodityErr: '',
      companyTinErr: '',
      companyRegNoErr: '',
      creditTermErr: '',
      creditTypeErr: '',
      companyList: [],
      companyName: '',
      companyTIN: '',
      companyRegNo: '',
      postcodeList: [],
      stateList: [],
      countryList: [],
      defaultAddressData: {
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
      },
      reportHdrCheck: false,
      showInfoFromJob: false,
      selectedJobInfo: null,
      showFromTemplate: false,
      jobList: [],
      gweight: '',
      measurement: '',
      commodity: '',
      updateJob: false,
      // selectedContainerNoInfolist: [],
      leftSideTextDefault: 'RMawb/OBL No.\t: \nHawb/HBL No.\t: \nFit/Vsl/Date\t: \nShipper\t\t: \nConsignee\t: ',
      leftSideText: 'RMawb/OBL No.\t: \nHawb/HBL No.\t: \nFit/Vsl/Date\t: \nShipper\t\t: \nConsignee\t: ',
      rightSideTextDefault: 'Origin/Dest\t: \nWeight/CBM\t: \nCommodity\t: \nRemarks\t\t: ',
      rightSideText: 'Origin/Dest\t: \nWeight/CBM\t: \nCommodity\t: \nRemarks\t\t: ',
      gweightErrMessage: '',
      measurementErrMessage: '',
      addressErrors: {
        addressLine1: '',
        addressLine2: '',
        addressLine3: '',
        addressLine4: '',
        postcode: '',
        city: '',
        state: '',
        country: '',
      },
      // #endregion

      // #region Payment data
      paymentModelist: [],
      selectedPaymentlist: null,
      bankCodeList: [],
      selectedBankCode: null,
      paymentDate: new Date(),
      paymentRefNoList: [],
      selectedPaymentRefNo: null,
      // #endregion

      // #region Attachment data
      attachmentsAction: '', // "Add" | "Edit" | "View"
      attachmentsPopupTitle: '',
      attachmentsPopupButtons: [],
      showAttachmentsPopup: false,
      isProjectable: false,
      docEditMode: false,
      // docEditButtons: [
      //   { text: 'Edit', index: 0, width: 60 }
      // ],
      showDocDetails: false,
      docEditIndex: -1,
      documentsList: [],
      oldDoc: '',
      documents: {
        docName: '',
        attachmentFile: [],
        filetype: '',
        docGuid: '',
        remarks: '',
        docID: 0,
      },
      deletedDocumentsList: [],
      docDataType: {
        'Doc Date': 'date',
      },
      selectedDoc: [],
      // addDocuments: false,
      // editDocumentIndex: '-1',
      // documentsLoading: false,
      showAttachmentProjector: false,
      newAtt: false,
      // #endregion

      //#region attachment projector data fields
      attachmentProjectorFileName: '',
      attachmentProjectorType: '',
      attachmentProjectorData: '',
      //#endregion

      // #region Events data
      // salesPersonSection: 0,
      salesPersonList: [],
      selectedSalesPersonList: null,
      salesTeamList: [],
      selectedSalesTeamList: null,
      offsetDocList: [],
      // #endregion

      // #region Update Job Type
      showUpdateDocType: false,
      updatePopupButtons: [{ text: 'Update' }, { text: 'Cancel', color: 'lightgray', textColor: 'black' }],
      selectedUpdatedInvoiceTypeList: null,
      selectedUpdatedInvoiceTypeListErrMessage: '',
      // #endregion

      // #region Settings System
      advColConfig: '', //Auto-tick Advance Collection checkbox for JobConfig contains
      //#endregion
    };
  },
  props: {},
  methods: {
    menuClicked: async function (e) {
      this.mainFilterIsOpen = false;
      this.clearErrMessage();
      this.clearAllData();
      switch (e['title']) {
        case `New ${this.pageTitle}`:
          this.action = 'N';
          this.viewMode = true;
          this.newlyAdd = true;
          this.creditTermIsDisabled = true;
          this.editButtons = [{ text: 'Edit', index: 0, width: 80 }];
          this.filterDate = true;
          this.filterSearch = false;
          this.openJobCharges = false;
          this.openAddNew = false;
          this.header['invoiceDate'] = new Date();
          this.header['InvoiceNo'] = '**********';
          this.leftSideText = this.leftSideTextDefault;
          this.rightSideText = this.rightSideTextDefault;
          this.selectedBillCustomer = null;
          this.headerSelectedCurrency = this.header['currencyList'].getSelected('MYR', 'Currency Code');
          if (this.header['invoiceTypeList'].length == 1) {
            this.selectedInvoiceTypeList = this.header['invoiceTypeList'][0];
            this.viewMode = false;
          }
          this.$nextTick(() => {
            this.currencySelected(this.headerSelectedCurrency);
            this.$refs['invoicetypeinput'].setFocus();
          });
          await this.getDetails(e['title']);
          this.popupShow = true;
          this.loadEventSummary();
          break;
        case `Edit ${this.pageTitle}`:
          if (this.selectedInvoiceListing.length == 0) {
            await this.$showAlert(
              'error',
              `No ${this.pageTitle} Selected`,
              `Please select 1 ${this.pageTitle.toLowerCase()} to edit`,
            );
          } else {
            if (this.selectedInvoiceListing['0']['Indicator'] == 'C') {
              await this.$showAlert(
                'error',
                `Selected ${this.pageTitle} already cancelled!`,
                `You are not allowed to edit cancelled ${this.pageTitle.toLowerCase()}`,
              );
              return;
            }
            const check = await this.$apiCallV2('/ARInvoice/ValidateFINAR', {
              docno: this.selectedInvoiceListing[0]['Invoice #'],
              doctype: this.pageType !== 'Debit' ? 'I' : 'D',
              action: 'E',
            });
            this.invoiceValidity = check[0]['Results'];
            if (check[0]['Results'] == '1') {
              const msg = check[0]['ErrMsg'].split(':');
              await this.$showAlert('error', `Cannot Edit ${this.pageTitle}`, `${msg[0] ?? ''}`);
              return;
            }
            this.chargesDetailsIndex = -1;
            this.action = 'E';
            this.editButtons = [{ text: 'Edit', index: 0, width: 80 }];
            this.viewMode = false;
            this.selectedBillCustomer = null;
            this.creditTermIsDisabled = false;
            this.openJobCharges = false;
            this.openAddNew = false;
            this.newlyAdd = false;
            await this.getDetails(e['title']);
            this.popupShow = true;
            this.loadEventSummary();
          }
          break;
        case `Delete ${this.pageTitle}`:
          if (this.selectedInvoiceListing.length == 0) {
            await this.$showAlert(
              'error',
              `No ${this.pageTitle} Selected`,
              `Please select an ${this.pageTitle.toLowerCase()} to delete`,
            );
          } else {
            if (this.selectedInvoiceListing['0']['Indicator'] == 'C') {
              await this.$showAlert(
                'error',
                `Selected ${this.pageTitle} already cancelled!`,
                `You are not allowed to delete cancelled ${this.pageTitle.toLowerCase()}`,
              );
              return;
            }
            const check = await this.$apiCallV2('/ARInvoice/ValidateFINAR', {
              docno: this.selectedInvoiceListing[0]['Invoice #'],
              doctype: this.pageType !== 'Debit' ? 'I' : 'D',
              action: 'E',
            });
            this.invoiceValidity = check[0]['Results'];
            if (check[0]['Results'] == '1') {
              const msg = check[0]['ErrMsg'].split(':');
              await this.$showAlert('error', `Cannot Delete ${this.pageTitle}`, `${msg[0]}`);
              return;
            }
            this.action = 'D';
            const confirmCancel = await this.$showAlert(
              'warning',
              `Deleting ${this.pageTitle} Record`,
              `Are you sure you want to delete ${this.pageTitle.toLowerCase()} ${this.selectedInvoiceListing[0]['Invoice #']} ?`,
              [
                { text: 'Yes', color: 'red', textColor: 'white' },
                { text: 'No', color: 'lightgray', textColor: 'black' },
              ],
            );
            if (confirmCancel == 'Yes') {
              this.showDeleteInvoicePopupWithRemarks = true;
            }
          }
          break;
        case `View ${this.pageTitle}`:
          if (this.selectedInvoiceListing.length == 0) {
            await this.$showAlert(
              'error',
              `No ${this.pageTitle} Selected`,
              `Please select an ${this.pageTitle.toLowerCase()} to view`,
            );
          } else {
            this.action = '';
            this.editButtons = [];
            this.newlyAdd = false;
            this.creditTermIsDisabled = true;
            this.openJobCharges = false;
            this.openAddNew = false;
            await this.getDetails(e['title']);
            this.popupShow = true;
            this.loadEventSummary();
            this.viewMode = true;
          }
          break;
        case `Copy Current ${this.pageTitle}`:
          break;
        case `Print ${this.pageTitle}`:
          if (this.selectedInvoiceListing.length === 0) {
            this.openPrintDocumentPage();
          } else {
            // only take the first selected row, will need to change logic if multiple selections are allowed in the future
            this.openPrintDocumentPage(this.selectedInvoiceListing[0]['Invoice #']);
          }

          break;
        case 'Export to CSV File':
          break;
        case 'Import Data': {
          const quotationPageLink = this.$router.resolve(`/Home/${this.$route.params['user']}/FINAR/Batch%20Import`);
          window.open(quotationPageLink.href, '_blank');
          break;
        }
        case `Update ${this.pageTitle} Type`:
          if (this.selectedInvoiceListing.length == 0) {
            this.$showAlert(
              'error',
              `No ${this.pageTitle} Selected`,
              `Please select 1 ${this.pageTitle.toLowerCase()} to update`,
            );
          } else if (this.selectedInvoiceListing[0]['Indicator'] == 'C') {
            this.$showAlert(
              'error',
              `Selected ${this.pageTitle} already cancelled!`,
              `You are not allowed to update cancelled ${this.pageTitle.toLowerCase()}`,
            );
          } else {
            this.showUpdateDocType = true;
          }
          break;
        case 'Authorize':
        case 'Unauthorize': {
          if (this.selectedInvoiceListing.length == 0) {
            this.$showAlert(
              'error',
              `No ${this.pageTitle} Selected`,
              `Please select 1 ${this.pageTitle.toLowerCase()} to ${e.toLowerCase()}`,
            );
          } else if (this.selectedInvoiceListing[0]['Indicator'] == 'C') {
            this.$showAlert(
              'error',
              `Selected ${this.pageTitle} already cancelled!`,
              `You are not allowed to update cancelled ${this.pageTitle.toLowerCase()}`,
            );
          } else {
            this.$fullscreenLoading(`${e['title'] == 'Authorize' ? 'Authorizing' : 'Unauthorizing'} ${this.pageTitle}`);
            const authToPost = {
              action: e['title'] == 'Authorize' ? 'A' : 'U',
              docrefname: `${this.pageTitle}`,
              docrefid: this.selectedInvoiceListing[0]['Invoice #'],
              date: this.selectedInvoiceListing[0]['Invoice Date'],
            };

            const authorizeResult = await this.$apiCallV2('/Payment/Authorization', authToPost);
            if (authorizeResult?.[0]?.['Results'] == 0) {
              this.$showAlert(
                'success',
                `${e['title']}d!`,
                `${this.pageTitle} ${this.selectedInvoiceListing[0]['Invoice #']} was successfully ${e['title']}d`,
              );
              this.invoiceListing = [];
              this.selectedInvoiceListing = [];
              this.$nextTick(async () => await this.refreshClicked('Main Page'));
            } else {
              this.$showAlert('error', `${e['title']} Unsuccessful`, `${authorizeResult[0]['ErrMsg']}`);
            }
            this.$fullscreenLoading();
          }
          break;
        }
        case 'Action':
          break;
      }
    },
    deletePopupClicked: async function (e) {
      switch (e) {
        case 'Delete':
          if (!this.deleteInvoiceRemarks || !this.deleteInvoiceRemarks.trim()) {
            this.deleteInvoiceErr = 'Please enter delete remarks!';
          } else {
            this.$fullscreenLoading(`Deleting Selected ${this.pageType}`);
            const deleteResult = await this.$apiCallV2('/ARInvoice/SaveArInvoice', {
              system: 'FINAR',
              action: 'D',
              txntype: this.pageType !== 'Debit' ? '0' : '1',
              arinvno: this.selectedInvoiceListing[0]['Invoice #'],
              deletereason: this.deleteInvoiceRemarks,
            });
            this.$fullscreenLoading();
            this.deleteInvoiceRemarks = '';
            this.showDeleteInvoicePopupWithRemarks = false;
            if (deleteResult[0]['Results'] == 0) {
              this.$showAlert(
                'success',
                'Deleted!',
                `${this.pageTitle.toLowerCase()} ${this.selectedInvoiceListing[0]['Invoice #']} was successfully deleted.`,
              );
              this.invoiceListing = [];
              this.selectedInvoiceListing = [];
              this.$nextTick(async () => await this.refreshClicked('Main Page'));
            } else {
              this.$showAlert('error', 'Delete unsuccessful', `${deleteResult[0]['ErrMsg']}`);
              this.invoiceListing = [];
              this.selectedInvoiceListing = [];
              this.$nextTick(async () => await this.refreshClicked('Main Page'));
            }
          }
          break;
        case 'Cancel':
          this.deleteInvoiceRemarks = '';
          this.showDeleteInvoicePopupWithRemarks = false;
          break;
      }
    },
    getDetails: async function (title) {
      this.popupTitle = title;
      if (this.selectedInvoiceListing.length > 0 && this.action != 'N') {
        await this.populateInvDetails(this.selectedInvoiceListing[0]['Invoice #']);
        this.createdBy = `${this.selectedInvoiceListing[0]['Created By'] ? this.selectedInvoiceListing[0]['Created By'].trim() : ''} ${this.selectedInvoiceListing[0]['Created Date'] ? new Date(this.selectedInvoiceListing[0]['Created Date']).formatString('dd/MM/yyyy HH:mm') : ''}`;
        this.updatedBy = `${this.selectedInvoiceListing[0]['Updated by'] ? this.selectedInvoiceListing[0]['Updated by'].trim() : ''} ${this.selectedInvoiceListing[0]['Updated Date'] ? new Date(this.selectedInvoiceListing[0]['Updated Date']).formatString('dd/MM/yyyy HH:mm') : ''}`;
      }
      this.popupShow = true;
    },
    // Populate invoice details
    populateInvDetails: async function (invno) {
      this.$fullscreenLoading('Getting data');
      const temptxn = this.pageType !== 'Debit' ? '0' : '1';
      this.arInvoice = (await this.$apiCallV2('/ARInvoice/GetARInvoice', { txntype: temptxn, invno: invno }))[
        'ARInvoiceDetails'
      ]['ARInvoice'];
      // #region header section
      this.selectedInvoiceTypeList =
        this.header['invoiceTypeList'].find((item) => item.JobTypeID == this.arInvoice['Invoice Type']) ?? null;
      this.totalAmt = this.$currencyFormat(this.arInvoice['total_amt']) ?? '';
      this.ftotalAmt = this.$currencyFormat(this.arInvoice['fTotal_amt']) ?? '';
      this.outstandingAmt = this.$currencyFormat(this.arInvoice['outstanding_amt']) ?? '';
      this.foutstandingAmt = this.$currencyFormat(this.arInvoice['fOutstanding_amt']) ?? '';
      const cur = this.arInvoice['total_amt'].toString() ?? '';
      this.totalInWords = this.convertCurrencyToWords(cur);
      this.headerSelectedCurrency = this.header['currencyList'].getSelected(
        this.arInvoice['currency']?.trim(),
        'Currency Code',
      );
      this.oldRate = this.arInvoice['rate'];
      this.oldCurrency = this.headerSelectedCurrency;
      this.currencySelected(this.headerSelectedCurrency, this.arInvoice['rate']);
      this.header['invoiceDate'] = new Date(this.arInvoice['InvDate']);
      this.header['InvoiceNo'] = this.arInvoice['InvNo'];
      this.header['invoiceRem1'] = this.arInvoice['Remark1'] ?? '';
      this.header['invoiceRem2'] = this.arInvoice['Remark2'] ?? '';
      this.header['invoiceRem3'] = this.arInvoice['Remark3'] ?? '';
      this.finalBill = this.arInvoice['finalbill'] === '1';
      this.advCollection = this.arInvoice['AdvanceCollection'] != 'FALSE';
      // if (this.arInvoice['AdvanceCollection'] == 'FALSE') {
      this.selectedCreditType =
        this.header['creditTypeList'].find((item) => item['Credit Type'] == this.arInvoice['CreditType']) ?? null;
      // }
      this.header['creditTerm'] = this.arInvoice['CreditTerm'] ?? '';
      this.gweight = this.arInvoice['GWeight'] ?? '';
      this.measurement = this.arInvoice['Measurement'] ?? '';
      this.commodity = this.arInvoice['Commodity'] ?? '';
      //move below to bottom of function because newJobChargesDetailsList is a watcher data
      // this.newJobChargesDetailsList = this.arInvoice['Charges'] ?? [];
      // if (this.newJobChargesDetailsList.length > 0) {
      //   this.newJobChargesDetailsList = this.newJobChargesDetailsList.map((item) => {
      //     return { ...item, 'Billing Customer': this.arInvoice['BillCust'] };
      //   });
      // }
      // #endregion

      // #region Addtional Info section
      const forjobList = this.arInvoice['Charges']?.filter((job) => job['Job No'].trim() != '') ?? []; //filter empty job
      if (forjobList.length > 0) {
        this.jobList = [];
        let current = '';
        forjobList.forEach((job) => {
          if (current != job['Job No'].trim()) {
            //filter duplicate job
            current = job['Job No'];
            this.jobList.push({ JobNo: job['Job No'] });
          }
        });
      }
      if (this.arInvoice['Job No']) {
        this.selectedJobInfo = this.jobList.getSelected(this.arInvoice['Job No'], 'JobNo');
        this.isUsingJobHeader = true;
        this.header['jobno'] = this.arInvoice['Job No'];
        this.jobnoList = await this.$apiCallV2(`/ARInvoice/GetQueryByJobConfig`, {
          doctype: this.pageType !== 'Debit' ? 'I' : 'D',
          jobtypeid: this.jobtypeid.toString(),
          table: 'JOB',
          top: this.rowLimitInputValue,
          jobno: this.header['jobno'],
          billcu_no: this.selectedBillCustomer?.['Customer Code'],
        }); //get the specific
        this.filterJobNoConfirm(this.jobnoList);
      }
      this.companyName = this.arInvoice['Delivery']?.['Company Name'] ?? '';
      this.companyTIN = this.arInvoice['Delivery']?.['Company Tin'] ?? '';
      this.companyRegNo = this.arInvoice['Delivery']?.['Company ROC'] ?? '';
      (this.defaultAddressData['addressLine2'] = this.arInvoice['Delivery']?.['Addr2'] ?? ''),
        (this.defaultAddressData['addressLine1'] = this.arInvoice['Delivery']?.['Addr1'] ?? ''),
        (this.defaultAddressData['addressLine3'] = this.arInvoice['Delivery']?.['Addr3'] ?? ''),
        (this.defaultAddressData['addressLine4'] = this.arInvoice['Delivery']?.['Addr4'] ?? ''),
        (this.defaultAddressData['postcode'] = this.arInvoice['Delivery']?.['PostCode'] ?? ''),
        (this.defaultAddressData['city'] = this.arInvoice['Delivery']?.['City'] ?? ''),
        (this.defaultAddressData['state'] = this.arInvoice['Delivery']?.['State'] ?? ''),
        (this.defaultAddressData['country'] = this.arInvoice['Delivery']?.['Country'] ?? ''),
        (this.leftSideText = this.arInvoice['ReportHeader']?.['JobInfoLeft'] ?? '');
      this.rightSideText = this.arInvoice['ReportHeader']?.['JobInfoRight'] ?? '';

      if (this.leftSideText != '' || this.rightSideText != '') {
        this.selectedHeaderDesc = this.headerDescRadioButtons[1];
        this.reportHdrCheck = true;
        this.showFromTemplate = true;
        this.showInfoFromJob = false;
      } else if (this.selectedJobInfo) {
        this.selectedHeaderDesc = this.headerDescRadioButtons[0];
        this.reportHdrCheck = true;
        this.showInfoFromJob = true;
        this.showFromTemplate = false;
      } else {
        // this.selectedHeaderDesc = null;
        this.reportHdrCheck = false;
        this.selectedHeaderDesc = null;
        this.showInfoFromJob = false;
        this.showFromTemplate = false;
      }
      // #endregion

      // #region Attachment section
      (this.documentsList = this.arInvoice['Attachment'] ?? []),
        // #endregion

        // #region Payment section
        // #endregion

        // #region Events section

        (this.selectedSalesTeamList = this.salesTeamList.find(
          (item) => item['Sales Team Code'] == this.arInvoice['SalesTeam']?.['Sales Team'],
        ));
      this.selectedSalesPersonList = this.salesPersonList.find(
        (item) => item['Sales Person Code'] == this.arInvoice['SalesTeam']?.['Sales Person'],
      );
      this.glEntry = this.arInvoice?.['GLEntry'] ?? [];
      this.offsetDocList = this.arInvoice?.['Offset'] ?? [];
      this.eInvoiceList = this.arInvoice?.['eInvoice'] ?? [];
      if (this.eInvoiceList.length > 0) {
        const getHighestId = this.eInvoiceList.reduce((max, item) => {
          return item['#'] > max ? Number(item['#']) : max;
        }, 0);
        const getLatestObj = this.eInvoiceList.find((obj) => obj['#'] == getHighestId);
        this.arInvoice['LHDN Submission'] = getLatestObj?.['Status'][0];
      } else {
        this.arInvoice['LHDN Submission'] = 'P';
      }

      // #endregion

      //move to here for the watcher data
      this.newJobChargesDetailsList = this.arInvoice['Charges'] ?? [];
      if (this.newJobChargesDetailsList.length > 0) {
        this.newJobChargesDetailsList = this.newJobChargesDetailsList.map((item) => {
          return { ...item, 'Billing Customer': this.arInvoice['BillCust'] };
        });
      }

      this.$fullscreenLoading();
    },
    addEditCharges: async function (type) {
      this.clearErrMessage();
      if (type == 'copy') {
        if (this.selectedSubDetails.length > 0) {
          // if(this.newJobChargesDetailsList.length > 0) {
          const check = this.newJobChargesDetailsList.find(
            (item) => item['Txnid'] == this.selectedSubDetails[0]['Txnid'],
          );
          if (check != undefined) {
            this.$showAlert('warning', 'Duplicated Job Charges', 'Selected Job Charges has already been added.');
          } else {
            const temp = this.newJobChargesDetailsList;
            this.newJobChargesDetailsList = [];
            const highestDetId = temp.reduce((max, obj) => {
              return Math.max(max, parseInt(obj['#'], 10));
            }, 0);
            let tempSub = this.newSubDetailsList;
            const gstEnableChecking = await this.GSTChecking();
            this.$fullscreenLoading('Adding Invoice Charges from Job Charges');

            for (const item of this.selectedSubDetails) {
              const getChargesCode = this.chargesCodeList.getSelected(item['Charges Code'], 'Charge Code');
              await this.selectedChargesCodeIsSelect(getChargesCode);
              const getIndex = this.selectedSubDetails.indexOf(item);
              const rate =
                this.internalCustomer != '0' ? '0'
                : this.selectedBillCustomer?.['Default SST Tax Code'] != '' ?
                  this.selectedBillCustomer?.['Default SST Tax Rate']?.toString()
                : item['Srv Exempt Code'] ? item['Srv Exempt Rate']
                : item['Srv Tax Rate'];
              const taxCode =
                this.internalCustomer != '0' ? '0'
                : this.selectedBillCustomer?.['Default SST Tax Code'] != '' ?
                  this.selectedBillCustomer?.['Default SST Tax Code']?.toString()
                : item['Srv Exempt Code'] ? item['Srv Exempt Code']
                : item['ARGST2TaxCode'];
              const myrTot = Number(item['Selling Amount']).toFixed(2); //myr equivalent selling total price, no recalculation needed, just take from job charges
              const tempTax = (Number(rate) / 100) * Number(myrTot) ?? '0.00';
              const srvTaxAmt = Number(tempTax).toFixed(2).toString();

              const tempfsrvTaxAmt = ((Number(rate) / 100) * item['Selling Amount']).toFixed(2).toString() ?? '0.00';
              const fsrvTaxAmt = ((Number(rate) / 100) * item['Selling FAmount']).toFixed(2).toString() ?? '0.00';
              const netInclTax = (Number(myrTot) + Number(srvTaxAmt)).toFixed(2);
              const fnetInclTax = (Number(item['Selling FAmount']) + Number(fsrvTaxAmt)).toFixed(2);
              const taxAmt =
                this.$currencyFormat((Number(item['ARGST2TaxRate'] ?? '0') * Number(item['Selling Amount'])) / 100) ??
                '0';

              const chargesDetails = {
                'Charges Code': item['Charges Code'],
                Classification: getChargesCode['Classification'],
                'Job No': item['Job No'],
                Qty: item['Qty'] ?? '1',
                'Selling Amount': netInclTax ?? '0', // net incl tax
                'Selling FAmount': fnetInclTax ?? '0',
                'Selling Total': item['Selling Amount'] ?? '0',
                'Selling FTotal': item['Selling FAmount'] ?? '0',
                'Selling Rate': item['Selling Rate'] ?? this.header['exchRate'],
                Currency: item['Selling Currency'] ?? this.headerSelectedCurrency['Currency Code'],

                'Mark Up FAmount': item['Mark Up FAmount'] ?? '0.00',
                'Mark Up Amount': this.$currencyFormat(item['Mark Up Amount']) ?? '0',

                'Srv Tax Amount': tempfsrvTaxAmt ?? '0', //sst
                'Srv Tax FAmount': fsrvTaxAmt, //sst
                'Srv Tax Rate': rate, //sst
                // 'Tax Code': gstEnableChecking ? item['ARGST2TaxCode'] :( this.internalCustomer != '0' ? '' : (item['Srv Exempt Code'] ? item['Srv Exempt Code'] : '')), //gst
                'Tax Code': taxCode, //sst

                Description: getChargesCode?.['Description'] ?? '',
                'Consignment No': item['CN #'] ?? '',
                'Cont No': item['Cont No'],

                'Tax Amt': gstEnableChecking ? taxAmt.toString() : '', //gst
                'Tax FAmount': gstEnableChecking ? Number(taxAmt) * Number(item['Selling Rate']) : '', //gst
                'Tax Rate': gstEnableChecking ? item['ARGST2TaxRate'] : '', //gst

                Notes: item['Remark'],
                AdjType: item['AdjType'] ?? '',
                'Group Code': item['GroupCode'] ?? '',
                'Payee Type': item['PayeeType'] ?? '',
                'Payee Code': item['PayeeCode'] ?? '',
                'Cost Code': this.selectedCostCode ? this.selectedCostCode['Cost Code'] : '',
                UOM: item['UOM'] ?? '',
                'Buying Amount': item['Buying Amount'] ?? '0',
                'Buying Famount': item['Buying Famount'] ?? '0',
                'Buying Currency': item['Buying Currency'] ?? this.headerSelectedCurrency['Currency Code'],
                'Buying Rate': item['Buying Rate'] ?? this.header['exchRate'],
                RecordSource: item['RecordSource'] ?? '',
                'Billing Customer': item['Billing Customer'],
                '#': Number(highestDetId) + Number(getIndex) + 1,
                Action: 'N',
                'User ID': '',
                DateUpdated: '',
                Txnid: item['Txnid'],
                JobTxnID: item['Txnid'],
                copy: true,
              };
              temp.push(chargesDetails);
            }
            this.selectedSubDetails.forEach((copyItem) => {
              tempSub = tempSub.filter((item) => item['Txnid'] != copyItem['Txnid']);
              this.tempNewSubDetailsList.push(copyItem);
            });

            this.newSubDetailsList = [];
            this.$nextTick(() => {
              this.newJobChargesDetailsList = temp;
              this.newSubDetailsList = tempSub;
              this.selectedSubDetails = [];
            });
            this.$fullscreenLoading();
          }
        } else {
          this.$showAlert('error', 'No Job Charges selected', 'Please select at least 1 job charges to add.');
        }
      } else {
        const temp = this.newJobChargesDetailsList;
        const details = this.$refs['foreignCurrency'].getDetails();
        let error = false;
        if (!this.selectedChargesCode) {
          this.selectedChargesCodeErr = 'Charges Code is required!';
          this.requiredError.push({ key: 'chargesCode', value: 'Charges Code is required!' });
          error = true;
        }
        if (this.itemNote && this.itemNote.length > 2000) {
          this.itemNoteErr = 'Item Note length cannot exceed 2000 characters!';
          this.requiredError.push({ key: 'itemNote', value: 'Item Note length cannot exceed 2000 characters!' });
          error = true;
        }

        if (details == null) {
          this.$refs['foreignCurrency'].$el.scrollIntoView({ behavior: 'smooth' });
          error = true;
        }
        let tempPayeeCode = '';
        if (this.payableChecking != '0' && this.selectedJobno && !this.recordSource) {
          if (!this.selectedPayeeCode && this.selectedJobno) {
            this.payeeCodeError = 'Payee Code is Required!';
            error = true;
          }
          if (!this.selectedPayeeType && this.selectedJobno) {
            this.payeeTypeError = 'Payee Type is Required!';
            error = true;
          }
        }

        if (error) return;

        if (this.selectedPayeeType) {
          switch (this.selectedPayeeType['Party'].trim()) {
            case 'CA/FF/OA/SA':
              tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Agent Code'] : '';
              break;
            case 'Creditor':
              tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Payee Code'] : '';
              break;
            case 'AR':
              tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Customer Code'] : '';
              break;
            case 'Employee':
              tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Employee Code'] : '';
              break;
            case 'Forwarding Agent':
              tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Frt Forwarder Code'] : '';
              break;
            case 'Haulier':
              tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Haulier Code'] : '';
              break;
            case 'Port Operator':
              tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Operator Code'] : '';
              break;
            case 'Supplier':
              tempPayeeCode = this.selectedPayeeCode ? this.selectedPayeeCode['Supplier Code'] : '';
              break;
          }
        }
        const highestDetId = temp.reduce((max, obj) => {
          return Math.max(max, parseInt(obj['#'], 10));
        }, 0);

        this.newJobChargesDetailsList = [];
        const chargesDetails = {
          'Charges Code': this.selectedChargesCode ? this.selectedChargesCode['Charge Code'] : '',
          Classification: this.selectedChargesCode ? this.selectedChargesCode['Classification'] : '',
          'Job No': this.selectedJobno ? this.selectedJobno['Job No'] : '',
          Qty: details['quantity'] ? details['quantity'] : '',
          'Selling Amount': details['tax']['netInclTax'] ? details['tax']['netInclTax'] : '', // myr equivalent
          'Selling FAmount': details['tax']['fnetInclTax'] ? details['tax']['fnetInclTax'] : '',
          'Selling Unit Price':
            details['myrEquivalent']['sellingUnitPrice'] ? details['myrEquivalent']['sellingUnitPrice'] : '',
          'Selling FUnit Price': details['selling']['unitPrice'] ? details['selling']['unitPrice'] : '',
          'Selling FTotal': details['selling']['totalPrice'] ? details['selling']['totalPrice'] : '',
          'Selling Total':
            details['myrEquivalent']['sellingTotalPrice'] ? details['myrEquivalent']['sellingTotalPrice'] : '',
          'Selling Rate': details['selling']['exchRate'] ? details['selling']['exchRate'] : '',
          Currency:
            details['selling']['currency']['Currency Code'] ? details['selling']['currency']['Currency Code'] : '',
          'Mark Up Amount':
            details['myrEquivalent']['markupTotalPrice'] ? details['myrEquivalent']['markupTotalPrice'] : '',
          'Mark Up FAmount': details['markup']['totalPrice'] ? details['markup']['totalPrice'] : '',
          'Markup Unit Price':
            details['myrEquivalent']['markupUnitPrice'] ? details['myrEquivalent']['markupUnitPrice'] : '',
          'FMark Up Unit Price': details['markup']['unitPrice'] ? details['markup']['unitPrice'] : '',
          'Srv Tax Amount': details['tax']['srvTaxAmt'] ? details['tax']['srvTaxAmt'] : '', // myr equivalent
          'Srv Tax FAmount': details['tax']['fsrvTaxAmt'] ? details['tax']['fsrvTaxAmt'] : '',
          'Srv Tax Rate': details['tax']['srvTaxRate'] ? details['tax']['srvTaxRate'] : '',
          'Tax Code':
            details['tax']['gsttaxCode'] ? details['tax']['gsttaxCode']
            : details['tax']['sstTaxCode'] ? details['tax']['sstTaxCode']
            : '',
          Description: this.invoiceDesc ? this.invoiceDesc : '',
          'Consignment No': this.selectedCNNO ? this.selectedCNNO['Consignment No'] : '',
          'Cont No': this.selectedcontno ? this.selectedcontno['Cont No'] : '',
          'Tax Amt': details['tax']['taxAmt'] ? details['tax']['taxAmt'] : '', //gst
          'Tax FAmount': details['tax']['ftaxAmt'] ? details['tax']['ftaxAmt'] : '', //gst
          'Tax Rate': details['tax']['taxRate'] ? details['tax']['taxRate'] : '', //gst
          Notes: this.itemNote ?? '',
          AdjType: this.selectedAdjustment ? this.selectedAdjustment['Code'] : '',
          'Group Code': this.freeTextGroupCode ?? '',
          'Cost Code': this.selectedCostCode ? this.selectedCostCode['Cost Code'] : '',
          UOM: details['uom'] ? details['uom']['UOM Code'] : '',
          'Buying Amount':
            details['myrEquivalent']['buyingTotalPrice'] ? details['myrEquivalent']['buyingTotalPrice'] : '',
          'Buying Famount': details['buying']['totalPrice'] ? details['buying']['totalPrice'] : '',
          'Buying Unit Price':
            details['myrEquivalent']['buyingUnitPrice'] ? details['myrEquivalent']['buyingUnitPrice'] : '',
          'Buying Currency':
            details['buying']['currency']['Currency Code'] ? details['buying']['currency']['Currency Code'] : '',
          'Buying Rate': details['buying']['exchRate'] ? details['buying']['exchRate'] : '',
          'FBuying Unit Price': details['buying']['unitPrice'] ? details['buying']['unitPrice'] : '',
          // 'Payee Type':
          //   (this.selectedJobno && !this.recordSource) || this.action == 'E' ?
          //     this.selectedPayeeType ?
          //       this.selectedPayeeType['Party Code']
          //     : ''
          //   : '',
          'Payee Type': this.selectedPayeeType ? this.selectedPayeeType['Party Code'] : '', //remove the condition because UI should already block it from changing the value
          // 'Payee Code': (this.selectedJobno && !this.recordSource) || this.action == 'E' ? tempPayeeCode : '',
          'Payee Code': tempPayeeCode ?? '',
          'Billing Customer': this.selectedBillCustomer?.['Customer Code'],
          '#':
            this.selectedNewJobChargesDetails.length > 0 ? this.selectedNewJobChargesDetails[0]['#'] : highestDetId + 1,
          Action:
            this.selectedNewJobChargesDetails.length == 0 ? 'N'
            : this.selectedNewJobChargesDetails?.['0']['Action'] ? this.selectedNewJobChargesDetails?.['0']['Action']
            : this.action,
          'User ID': '',
          DateUpdated: '',
          RecordSource:
            this.selectedNewJobChargesDetails.length > 0 ? this.selectedNewJobChargesDetails[0]['RecordSource'] : '3',
          // 'TabSource': 'A', //vqy need to discuss in meeting...
        };
        if (this.pageTitle == 'Debit Note') {
          chargesDetails['Invoice Ref No'] = this.invRefNo ? this.invRefNo : '';
        }
        this.$nextTick(() => {
          if (this.selectedNewJobChargesDetails.length > 0) {
            chargesDetails['JobTxnID'] = this.selectedNewJobChargesDetails['0']['JobTxnID'];
            chargesDetails['Txnid'] = this.selectedNewJobChargesDetails['0']['Txnid'];
            temp.splice(this.chargesDetailsIndex, 1, chargesDetails);
            this.openJobCharges = false;
            this.openAddNew = false;
          } else {
            temp.push(chargesDetails);
          }
          this.newJobChargesDetailsList = temp;
          this.clearChargesDetails();
          this.$refs['foreignCurrency'].clearAll();
          this.showDetails = false;
          this.chargesDetailsIndex = -1;
        });
      }
    },
    creditTermFocusChanged: function () {
      this.creditTermErr = '';
    },
    jobInputChanged: async function (state) {
      if (!state) {
        if (this.header['jobno'] != '') {
            this.jobnoList = await this.$apiCallV2(`/ARInvoice/GetQueryByJobConfig`, {
              doctype: this.pageType !== 'Debit' ? 'I' : 'D',
              jobtypeid: this.jobtypeid.toString(),
              table: 'JOB',
              top: this.rowLimitInputValue,
              jobno: this.header['jobno'].trim(),
            }); //get the specific job

            if (this.jobnoList && this.jobnoList.length > 0) {
              const selectedBillCust = this.header['billingCustList'].find(
                (bill) => bill['Customer Code'].trim() == this.jobnoList[0]['Billing Customer'],
              );
  
              if (this.newJobChargesDetailsList.length > 0) {
                if (selectedBillCust['Customer Code'] != this.newJobChargesDetailsList[0]['Billing Customer']) {
                  await this.$showAlert(
                    'error',
                    `Invalid Job No for this customer!`,
                    `Job Billing Customer: ${selectedBillCust['Customer Code']}`,
                  );
                  this.header['jobno'] = '';
                  this.isUsingJobHeader = false;
                  this.selectedFilterJobNoConfirmStr = '';
                  this.selectedFilterJobNoConfirm = [];
                  return;
                }
              }
  
              if (!this.selectedBillCustomer) {
                this.selectedBillCustomerIsSelected(selectedBillCust);
              }
              this.filterJobNoConfirm(this.jobnoList);
              this.isUsingJobHeader = true;
              await this.refreshClicked('');
            } else {
              this.$showAlert('error', 'No Record Found', 'Please select a valid Job No.');
            }
        } else {
          this.isUsingJobHeader = false;
          this.selectedFilterJobNoConfirmStr = '';
          this.selectedFilterJobNoConfirm = [];
          // this.jobnoList = await this.$apiCallV2(`/ARInvoice/GetQueryByJobConfig`,  {doctype: this.pageType !== 'Debit' ? 'I' : 'D', jobtypeid: this.jobtypeid.toString(), table: 'JOB', top: this.rowLimitInputValue});
          await this.refreshClicked('');
        }
      }
    },
    deleteDocument: async function () {
      if (this.selectedDoc.length == 0) {
        this.$showAlert('error', 'No Document Selected', 'Please select at least 1 document to delete.');
      } else {
        const confirmCancel = await this.$showAlert(
          'warning',
          'Deleting Attachment',
          `Are you sure you want to delete this attachment ?`,
          [
            { text: 'Yes', color: 'red', textColor: 'white' },
            { text: 'No', color: 'lightgray', textColor: 'black' },
          ],
        );
        if (confirmCancel == 'No') return;

        let existingData = false;
        const tempdeleted = this.deletedDocumentsList;
        this.deletedDocumentsList = [];
        for (const d of this.selectedDoc) {
          const document = {
            Action: 'D',
            'Document GUID': d['Document GUID'],
          };
          if (d['Document GUID']) {
            tempdeleted.push(document);
            existingData = true;
          }
        }
        const temp = this.documentsList;
        const index = temp.findIndex((item) => {
          return existingData ?
              item['Document GUID'] == this.selectedDoc[0]['Document GUID']
            : item['ID'] == this.selectedDoc[0]['ID'];
        });
        temp.splice(index, 1);
        this.documentsList = [];

        this.$nextTick(() => {
          this.deletedDocumentsList = tempdeleted;
          this.documentsList = temp;
          this.selectedDoc = [];
        });
      }
    },
    attachmentBtnClicked: async function (type) {
      this.attachmentsAction = type;
      this.documents['remarks'] = '';
      this.documents['docName'] = '';
      this.documents['attachmentFile'] = '';
      this.documents['filetype'] = '';
      this.documents['docGuid'] = '';
      this.documents['remarks'] = '';
      if (type == 'edit') {
        if (this.selectedDoc.length == 0) {
          await this.$showAlert('error', 'No Attachment Selected', 'Please select an Attachment to edit');
          return;
        }
        this.attachmentsPopupButtons = [{ text: 'Edit' }, { text: 'Cancel', color: 'lightgray' }];
        // populate selected documents;
        this.documents['remarks'] = this.selectedDoc[0]['Doc Remark'];
        this.documents['docName'] = this.selectedDoc[0]['File Name'];
        this.documents['attachmentFile'] = this.selectedDoc[0]['Doc Image'];
        this.documents['filetype'] = this.selectedDoc[0]['File Type'];
        this.documents['docGuid'] = this.selectedDoc[0]['Document GUID'];
        this.documents['remarks'] = this.selectedDoc[0]['Doc Remark'];
        this.showAttachmentsPopup = true;
        this.attachmentsPopupTitle = 'Edit Attachment';
      } else if (type == 'add') {
        this.selectedDoc = [];
        this.attachmentsPopupButtons = [{ text: 'Add' }, { text: 'Cancel', color: 'lightgray' }];
        this.showAttachmentsPopup = true;
        this.attachmentsPopupTitle = 'Add Attachment';
      }
    },
    attachmentIsProjectable: function () {
      if (!this.attachmentProjectorFileName || !this.attachmentProjectorType) {
        // if either of these are blank
        return false;
      }

      const filenameSplit = this.attachmentProjectorFileName.trim().split('.');
      const fileExtension = filenameSplit[filenameSplit.length - 1];
      const projectableExtensions = ['pdf', 'txt', 'json', 'mp3', 'wav', 'mp4', 'webm', 'ogg'];
      return this.attachmentProjectorType.startsWith('image/') || projectableExtensions.includes(fileExtension);
    },
    projectAttachment: async function (file) {
      // file could be a file object or a JS object
      // if (!file && process.env['NODE_ENV'] == 'development') {
      //   console.error("No file was passed to projectAttachment. Check for logic errors");
      //   console.trace();
      //   return;
      // }

      this.$fullscreenLoading('Preparing attachment');
      if (file instanceof File) {
        // file object passed
        this.attachmentProjectorFileName = file['name'];
        this.attachmentProjectorType = file['type'];
        this.attachmentProjectorData = URL.createObjectURL(file);
      } else {
        // JS object passed
        this.attachmentProjectorFileName = file['File Name'];
        this.attachmentProjectorType =
          file['MIME Type'] ||
          (await this.$apiCallV2(`/ARInvoice/GetMIMEType?filename=${this.attachmentProjectorFileName}`));
        const byteCharacters = atob(
          file['File Data'].startsWith('data:') ? file['File Data'].split(',')[1] : file['File Data'],
        );
        // if File Data is a data URL instead of just base64 data, then remove the prefix, MIME type and base64 indicator before converting to a string
        const untypedByteArray = [];
        for (let index = 0; index < byteCharacters.length; index++) {
          untypedByteArray.push(byteCharacters.charCodeAt(index));
        }

        const blob = new Blob([new Uint8Array(untypedByteArray)], { type: this.attachmentProjectorType });
        this.attachmentProjectorData = URL.createObjectURL(blob);
      }

      this.isProjectable = this.attachmentIsProjectable();
      this.showAttachmentProjector = true;
      this.$fullscreenLoading();
    },
    loadEventSummary: function () {
      if (!this.arInvoice?.['IRBM']) {
        this.arInvoice['IRBM Ref No'] = 'P';
      }
      for (const key in this.arInvoice) {
        // if ( this.arInvoice.hasOwnProperty(key)) {
        if (Object.prototype.hasOwnProperty.call(this.arInvoice, key)) {
          const indicatorName = this.getIndicatorName(key, this.arInvoice[key], 'title');
          const backgroundColor = this.getIndicatorName(key, this.arInvoice[key], 'background');
          const element = document.getElementById(key);
          if (element) {
            element.textContent = indicatorName;
            element.style.backgroundColor = backgroundColor;
          }
        }
      }
    },
    downloadAttachment: function () {
      const anchor = document.createElement('a');
      anchor['href'] = this.attachmentProjectorData;
      anchor['download'] = this.selectedDoc[0]['File Name'];
      anchor.click();
    },
    closeProjector: function () {
      this.attachmentProjectorType = ''; // clear MIME Type and base64, because base64 is quite inefficient
      this.attachmentProjectorData = ''; // leaving it there after the projector is closed is quite wasteful
      this.showAttachmentProjector = false;
    },
    addDocument: async function (buttonText) {
      let temp;
      let highestID = 1;
      let document = null;
      switch (buttonText) {
        case 'Add':
          if (!this.documents['docName']) {
            await this.$showAlert('error', 'No Attachment Added', 'Please select an Attachment to proceed');
            return;
          }
          temp = [...this.documentsList];
          this.documentsList = [];

          for (const d of temp) {
            if (d['ID'] > highestID) {
              highestID = d['ID'];
            }
          }

          document = {
            Action: 'N',
            'Doc Remark': !this.documents['remarks'] ? '' : this.documents['remarks'],
            'Doc Date': new Date(),
            'File Name': !this.documents['docName'] ? '' : this.documents['docName'],
            'File Type': !this.documents['filetype'] ? '' : this.documents['filetype'],
            'Doc Image': !this.documents['attachmentFile'] ? '' : this.documents['attachmentFile'],
            'Document GUID': !this.documents['docGuid'] ? '' : this.documents['docGuid'],
            ID: !this.documents['docID'] ? ++highestID : this.documents['docID'],
            _attachmentAction: 'New', // hidden column
          };
          this.$nextTick(() => {
            temp.push(document);
            this.documentsList = temp;
            this.oldDoc = this.documents['docName'];
            this.clearDocumentData();
          });
          this.showAttachmentsPopup = false;
          break;
        case 'Edit': {
          temp = [...this.documentsList];
          for (const d of temp) {
            if (d['ID'] > highestID) {
              highestID = d['ID'];
            }
          }
          let existingData = false;
          for (const d of this.selectedDoc) {
            document = {
              Action: !this.documents['docGuid'] ? 'N' : 'E',
              'Doc Remark': !this.documents['remarks'] ? '' : this.documents['remarks'],
              'Doc Date': new Date(),
              'File Name': !this.documents['docName'] ? '' : this.documents['docName'],
              'File Type': !this.documents['filetype'] ? '' : this.documents['filetype'],
              'Doc Image': !this.documents['attachmentFile'] ? '' : this.documents['attachmentFile'],
              'Document GUID': !this.documents['docGuid'] ? '' : this.documents['docGuid'],
              ID: !this.documents['docID'] ? ++highestID : this.documents['docID'],
              // "_file": file, // hidden column
            };
            if (d['Document GUID']) {
              existingData = true;
            }
          }
          let temp = this.documentsList;
          const index = temp.findIndex((item) => {
            return existingData ?
                item['Document GUID'] == this.selectedDoc[0]['Document GUID']
              : item['ID'] == this.selectedDoc[0]['ID'];
          });
          temp.splice(index, 1, document);
          this.documentsList = [];
          this.$nextTick(() => {
            this.oldDoc = this.documents['docName'];
            this.documentsList = temp;
            this.clearDocumentData();
          });
          this.showAttachmentsPopup = false;
          break;
        }
        case 'Cancel':
          this.showAttachmentsPopup = false;
          this.clearDocumentData();
          break;
      }
    },
    GSTChecking: async function () {
      const companyList = await this.$apiCallV2('/Master/GetListMaster', { masterfile: 'COMPANY' });
      this.taxCodeList = this.$deepTrimJsonV3(
        await this.$apiCallV2(`/Master/GetListMaster`, { masterfile: 'ARTAXCODE', module: 'GST' }),
      );
      const details = (
        await this.$apiCallV2('/Master/GetDetailsMaster', {
          masterfile: 'COMPANY',
          module: 'MASTER',
          recordid: companyList[0]['Company Code'],
        })
      )['Company'];
      let status = false;
      if (
        details['CompanyGST2Enabled'] == 1 &&
        new Date(details['CompanyGST2EffectiveDate']) <= new Date() &&
        new Date(details['CompanyGSTEffectiveDate']) > new Date()
      ) {
        status = true;
      } else if (new Date() >= new Date(details['CompanyGSTEffectiveDate']) && details['CompanyGSTEnabled'] == 1) {
        status = false;
      }

      return status;
    },
    copyStatus: function () {
      this.showJobStatusList = true;
      const temp = this.statusListCategory;
      this.statusListCategory = [];
      this.$nextTick(() => {
        setTimeout(() => {
          this.statusListCategory = temp;
        }, 500);
      });
    },
    JobStatusPopupClicked: async function (e) {
      switch (e) {
        case 'OK':
          if (this.selectedStatusListCategory.length == 0) {
            this.$showAlert('warning', 'No Job Status Selected', 'Please select a job status to add');
          } else {
            const dataToPost = { listcategory: this.selectedStatusListCategory[0]['List Category'] };
            if (this.selectedJobno) {
              dataToPost['jobno'] = this.selectedJobno['Job No'];
            }
            const temp = await this.$apiCallV2('/DebitNote/GetInvoiceStatusList', dataToPost);
            this.itemNote = this.itemNote.concat('\n', temp?.['statusnotes']);
            this.showJobStatusList = false;
          }
          break;
        case 'Cancel':
          this.selectedStatusListCategory = [];
          this.showJobStatusList = false;
          break;
      }
    },
    checkPopupEntryFields: function () {
      this.clearErrMessage();
      let error = false;
      if (this.header['invoiceDate']) {
        const inputDate = new Date(this.header['invoiceDate']);
        const currentDate = new Date();
        const thresholdDate = new Date();

        thresholdDate.setFullYear(currentDate.getFullYear() - 30);
        if (inputDate <= thresholdDate || inputDate.getFullYear() > currentDate.getFullYear() + 1) {
          this.dataTimeErr = `${this.pageTitle} Date is invalid!`;
          this.requiredError.push({ key: 'dataTimeErr', value: `${this.pageTitle} Date is invalid!` });
          error = true;
        }
      } else {
        this.dataTimeErr = `${this.pageTitle} Date is required!`;
        this.requiredError.push({ key: 'dataTimeErr', value: `${this.pageTitle} Date is required!` });
        error = true;
      }

      if (!this.selectedInvoiceTypeList) {
        this.invoiceTypeErr = `${this.pageTitle} Type is required!`;
        this.requiredError.push({ key: 'invoicetypeinput', value: `${this.pageTitle} Type is required!` });
        error = true;
      }
      if (!this.header['invoiceDate']) {
        this.dataTimeErr = `${this.pageTitle} Date is required!`;
        this.requiredError.push({ key: 'dataTimeErr', value: `${this.pageTitle} Date is required!` });
        error = true;
      }
      if (!this.headerSelectedCurrency) {
        this.currErr = 'Currency is required!';
        this.requiredError.push({ key: 'currErr', value: 'Currency is required!' });
        error = true;
      }
      if (!this.header['exchRate']) {
        this.exchErr = 'Exchange Rate is required';
        this.requiredError.push({ key: 'exchErr', value: 'Exchange Rate is required!' });
        error = true;
      }
      if (Number(this.header['exchRate']) == 0) {
        this.exchErr = 'Exchange Rate is invalid';
        this.requiredError.push({ key: 'exchErr', value: 'Exchange Rate is invalid!' });
        error = true;
      }
      if (!this.selectedBillCustomer) {
        this.billCustErr = 'Billing Customer is required!';
        this.requiredError.push({ key: 'billCustErr', value: 'Billing Customer is required!' });
        error = true;
      }
      if (this.companyName.length > 40) {
        this.companyNameErr = 'Company Name cannot exceed 40 digits!';
        this.requiredError.push({ key: 'companyNameErr', value: 'Company Name cannot exceed 40 digits!' });
        error = true;
      }
      if (this.header['creditTerm'].length > 4) {
        this.creditTermErr = 'Credit Type cannot exceed 4 digits!';
        this.requiredError.push({ key: 'creditTermErr', value: 'Credit Type cannot exceed 4 digits!' });
        error = true;
      }
      const check = this.header['creditTypeList'].find((item) => item['Credit Name'] == this.header['creditTypeStr']);
      if (this.header['creditTypeStr'] != '' && this.selectedCreditType == null && check == undefined) {
        this.creditTypeErr = 'Please select a  valid record!';
        this.requiredError.push({ key: 'creditTypeErr', value: 'Please select a valid record!' });
        error = true;
      }
      if (this.header['exchRate'].length > 19) {
        this.exchErr = 'Credit Type cannot exceed 19 digits!';
        this.requiredError.push({ key: 'exchErr', value: 'Credit Type cannot exceed 19 digits!' });
        error = true;
      }
      const regex = /^\d{1,11}(\.\d{1,4})?$/;
      if (this.measurement && !regex.test(this.measurement)) {
        this.measurementErrMessage = 'Measurement value is invalid!';
        this.requiredError.push({ key: 'measurementErrMessage', value: 'Measurement value is invalid!' });
        error = true;
      }
      if (this.gweight && !regex.test(this.gweight)) {
        this.gweightErrMessage = 'GWeight value is invalid!';
        this.requiredError.push({ key: 'gweightErrMessage', value: 'GWeight value is invalid!' });
        error = true;
      }
      if (this.defaultAddressData.addressLine1.length > 40) {
        this.addressErrors.addressLine1 = 'Address Line 1 cannot exceed 40 characters!';
        this.requiredMessages.push({ Key: 'addressLine1', Value: 'Address Line 1 cannot exceed 40 characters!' });
      }
      if (this.defaultAddressData.addressLine2.length > 40) {
        this.addressErrors.addressLine2 = 'Address Line 2 cannot exceed 40 characters!';
        this.requiredMessages.push({ Key: 'addressLine2', Value: 'Address Line 2 cannot exceed 40 characters!' });
      }
      if (this.defaultAddressData.addressLine3.length > 40) {
        this.addressErrors.addressLine3 = 'Address Line 3 cannot exceed 40 characters!';
        this.requiredMessages.push({ Key: 'addressLine3', Value: 'Address Line 3 cannot exceed 40 characters!' });
      }
      if (this.defaultAddressData.addressLine4.length > 40) {
        this.addressErrors.addressLine4 = 'Address Line 4 cannot exceed 40 characters!';
        this.requiredMessages.push({ Key: 'addressLine4', Value: 'Address Line 4 cannot exceed 40 characters!' });
      }
      if (this.defaultAddressData.city.length > 30) {
        this.addressErrors.city = 'City cannot exceed 30 characters!';
        this.requiredMessages.push({ Key: 'city', Value: 'City cannot exceed 30 characters!' });
      }

      return error;
    },
    requiredClicked: function (item) {
      const errorTabs = this.errorTabMapping.find((e) => e['key'] == item);
      if (errorTabs) {
        if (this.currentTabIndex != errorTabs['tab'] && errorTabs['tab'] >= 0) {
          this.currentTabIndex = errorTabs['tab'];
        }
      }
      this.$nextTick(() => {
        this.$refs[item].setFocus();
      });
    },
    saveClicked: async function () {
      const isInvalid = this.checkPopupEntryFields();

      if (isInvalid) {
        return;
      }

      if (this.openAddNew && this.selectedChargesCode) {
        const checking = await this.$showAlert(
          'warning',
          `Charge item not added yet`,
          `Do you wish to discard the changes and proceed to save?`,
          [{ text: 'Discard and Save', color: 'Red', textColor: 'white' }, { text: 'Cancel' }],
        );
        if (checking === 'Cancel') {
          return;
        }
        this.$nextTick(() => {
          this.clearChargesDetails();
        });
      }

      this.openJobCharges = false;
      this.openAddNew = false;

      if (this.totalAmt == 0) {
        const confirmTotalAmt = await this.$showAlert(
          'warning',
          `${this.pageTitle} total amount is 0`,
          `Are you sure you want to proceed?`,
          [{ text: 'Yes' }, { text: 'No' }],
        );

        if (confirmTotalAmt === 'No') {
          return;
        }

        this.finalBill = false;
      } else if (this.totalAmt < 0) {
        await this.$showAlert(
          'error',
          `Total ${this.pageTitle} Amt cannot be less than 0`,
          'Please review your charges list to save.',
        );
        return;
      }

      //only ask below after user click on save instead of on checkbox changes
      if (this.action == 'E' && this.newJobChargesDetailsList.length > 0) {
        const check = this.newJobChargesDetailsList.find((item) => item.finalbilcount > 0);
        if (check && this.finalBill) {
          const checking = await this.$showAlert(
            'warning',
            `${check['Job No']} have already Final Bill. Do you want to continue billing ?`,
            `If Yes, previous ${this.pageTitle.toLowerCase()} will mark as not Final Bill\nIf No, cannot use this ${this.pageTitle.toLowerCase()} to do Final Bill for this Job`,
            [{ text: 'Yes' }, { text: 'No' }],
          );

          if (checking == 'No') {
            this.finalBill == false;
          }
        }
      }

      const allDocList = this.deletedDocumentsList.concat(this.documentsList);
      const tempAttachment = allDocList.map((item) => {
        return {
          doccode: 'ATT',
          docrefno: '',
          remarks: item['Doc Remark'],
          status: '',
          docname: item['File Name'],
          docimage: item['Action'] == 'N' || this.newAtt ? item['Doc Image'] : '',
          docimagetype: item['File Type'],
          action: item['Action'],
          docguid: this.action == 'N' ? '' : item['Document GUID'], //no guid for new
        };
      });
      const allChargesList = this.newJobChargesDetailsList.concat(this.deletedNewJobChargesDetailsList);
      const tempChargesList = allChargesList.map((item) => {
        return {
          transactioncode: item['Group Code'],
          seqno: item['#'] ?? '', //no value
          jobno: item['Job No'] ?? '',
          servicetax: item['Srv Tax Rate'] ?? '',
          buying: parseFloat(item['Buying Amount'] || 0).toFixed(4),
          taxableamt: parseFloat(item['Srv Tax Amount'] || 0).toFixed(4),
          selling: parseFloat(item['Selling Amount'] || 0).toFixed(4),
          markup: parseFloat(item['Mark Up Amount'] || 0).toFixed(4),
          remarks1: '',
          type: '',
          remarks2: '',
          remarks3: item['Invoice Ref No'] ?? '',
          fbuying: parseFloat(item['Buying Famount'] || 0).toFixed(4),
          ftaxableamt: parseFloat(item['Srv Tax FAmount'] || 0).toFixed(4),
          fselling: parseFloat(item['Selling FAmount'] || 0).toFixed(4),
          fmarkup: parseFloat(item['Mark Up FAmount'] || 0).toFixed(4),
          sellingrate: item['Selling Rate'] ?? '',
          sellingcurrency: item['Currency'] ?? '',
          cnno: item['Consignment No'] ?? '',
          chargescode: item['Charges Code'] ?? '',
          remarks4: '',
          tabsource: 'D',
          chargesdesc: item['Description'] ?? '',
          action: item['Action'] ?? 'O',
          contno: item['Cont No'] ?? '',
          // 'jobtxnid': '',
          txnid: item['Txnid'] ?? '',
          uom: item['UOM'] ?? '',
          qty: item['Qty'] ?? '',
          // 'adjtype': item['Adjustment Type'] == 'Adjustment' ? 'A' : 'D' ?? '',
          adjtype: item['AdjType'] ?? '',
          billingfmt: '',
          rot: item['Rot'] ?? '',
          buyingrate: item['Buying Rate'] ?? '',
          buyingcurrency: item['Buying Currency'] ?? '',
          buyingunitprice: parseFloat(item['Buying Unit Price'] || 0).toFixed(4),
          fbuyingunitprice: parseFloat(item['FBuying Unit Price'] || 0).toFixed(4),
          sellingunitprice: parseFloat(item['Selling Unit Price'] || 0).toFixed(4),
          fsellingunitprice: parseFloat(item['Selling FUnit Price'] || 0).toFixed(4),
          costcode: item['Cost Code'] ?? '',
          orinetamt: parseFloat(item['orinetamount'] || 0).toFixed(4),
          taxcode: item['Tax Code'] ?? '',
          gsttaxcode: item['Tax Code'] ?? '',
          gsttaxrate: item['Tax Rate'] ?? '',
          gsttaxableamt: parseFloat(item['Tax Amt'] || 0).toFixed(4),
          gstftaxableamt: parseFloat(item['Tax FAmount'] || 0).toFixed(4),
          notes: item['Notes'] ?? '',
          // 'buyingrate': item['Buying Rate'] ?? '',
          // 'buyingcurrency': item['Buying Currency'] ?? '',
          sellingtotal: parseFloat(item['Selling Total'] || 0).toFixed(4),
          fsellingtotal: parseFloat(item['Selling FTotal'] || 0).toFixed(4),
          jobtxnid: item['JobTxnID'] ?? '',
          payeetype: item['Payee Type'] ?? '',
          payeecode: item['Payee Code'] ?? '',
        };
      });
      const dataToSave = {
        action: this.action,
        system: 'FINAR',
        invjobtype: this.selectedInvoiceTypeList['JobTypeID'],
        billcust: this.selectedBillCustomer?.['Customer Code'] ?? '',
        credittype: this.selectedCreditType?.['Credit Type'] ?? '',
        creditterm: this.header['creditTerm'] ?? '',
        invdate:
          this.header['invoiceDate'] ?
            new Date(this.header['invoiceDate']).formatString('yyyy-MM-dd')
          : new Date().formatString('yyyy-MM-dd'),
        // this.action == 'N' ?
        //   new Date().formatString('yyyy-MM-dd')
        // : new Date(this.header['invoiceDate']).formatString('yyyy-MM-dd'),
        currency: this.headerSelectedCurrency?.['Currency Code'] ?? '',
        rate: this.header['exchRate'] ?? '',
        advancecollection: this.advCollection ? '1' : '0',
        finalbill: this.finalBill ? '1' : '0',
        arinvno: this.action != 'N' ? this.header['InvoiceNo'] : '',
        remark1: this.header['invoiceRem1'] ?? '',
        remark2: this.header['invoiceRem2'] ?? '',
        remark3: this.header['invoiceRem3'] ?? '',
        total: this.totalAmt ?? '0',
        txntype: this.pageType !== 'Debit' ? '0' : '1',
        doctype: this.pageType !== 'Debit' ? 'I' : 'D',
        mknotfinal: '',
        gstinvoice: this.selectedInvoiceTypeList?.['Description'].includes('GST') ? '1' : '0',
        // region Invoice Charges
        invoicecharges: tempChargesList ?? [],
        //endregion

        // region Addtional Info
        deliverydetails: {
          companyname: this.companyName ?? '',
          companytin: this.companyTIN ?? '',
          companyregno: this.companyRegNo ?? '',
          addr1: !this.defaultAddressData['addressLine1'] ? '' : this.defaultAddressData['addressLine1'],
          addr2: !this.defaultAddressData['addressLine2'] ? '' : this.defaultAddressData['addressLine2'],
          addr3: !this.defaultAddressData['addressLine3'] ? '' : this.defaultAddressData['addressLine3'],
          addr4: !this.defaultAddressData['addressLine4'] ? '' : this.defaultAddressData['addressLine4'],
          postcode: !this.defaultAddressData['postcode'] ? '' : this.defaultAddressData['postcode'],
          city: !this.defaultAddressData['city'] ? '' : this.defaultAddressData['city'],
          state: !this.defaultAddressData['state'] ? '' : this.defaultAddressData['state'],
          country: !this.defaultAddressData['country'] ? '' : this.defaultAddressData['country'],
        },
        headerinfojobno: this.selectedJobInfo?.['JobNo'] ?? '',
        headerinfocheck:
          this.reportHdrCheck ?
            this.showFromTemplate ? '2'
            : this.showInfoFromJob && this.selectedJobInfo ? '1'
            : '0'
          : '0',
        jobinfoleft: this.showFromTemplate ? this.leftSideText : '',
        jobinforight: this.showFromTemplate ? this.rightSideText : '',
        gweight: this.gweight ?? '',
        measurement: this.measurement ?? '',
        commodity: this.commodity ?? '',
        updatejobcheck: this.updateJob ? '1' : '0',
        //endregion

        //region Attachment
        attachment: tempAttachment ?? [],
        //endregion

        //region Events
        // 'salesPerson': this.selectedSalesPersonList?.['Sales Person Code'] ?? null,
        // 'salesTeam': this.selectedSalesTeamList?.['Sales Team Code'] ?? null,
        //endregion
      };
      this.$fullscreenLoading(`Saving ${this.pageTitle}`);
      const result = await this.$apiCallV2('/ARInvoice/SaveArInvoice', dataToSave);
      this.$fullscreenLoading();

      if (result[0]['Results'] != 0) {
        if (this.action == 'N') {
          this.errorMessages.push(`There was an error creating ${this.pageTitle}: ${result[0]['ErrMsg']}`);
        } else {
          this.errorMessages.push(`There was an error editing ${this.pageTitle}: ${result[0]['ErrMsg']}`);
        }
        return;
      }

      if (result[0]['invno'] && this.action == 'N') {
        this.header['InvoiceNo'] = result[0]['invno'];
      }
      if ((this.reportHdrCheck && !this.showInfoFromJob && !this.showFromTemplate) || !this.selectedJobInfo) {
        this.selectedHeaderDesc = null;
        this.reportHdrCheck = false;
      }
      this.showInvoiceChargesTable = false;
      this.clearErrMessage();
      this.editButtons = [];
      this.$nextTick(async () => {
        await this.populateInvDetails(result[0]['invno']);
        this.showInvoiceChargesTable = true;
        await this.refreshClicked('Main Page');
      });

      if (this.action == 'N') {
        this.successMessages.push(`${result[0]['ErrMsg']}`);
      } else {
        this.successMessages.push(`${result[0]['ErrMsg']}`);
      }
      this.viewMode = true;
      this.newAtt = false;
      this.creditTermIsDisabled = true;
      this.action = '';
    },
    popupPrintClicked: function () {
      this.openPrintDocumentPage(this.header.InvoiceNo);
    },
    openPrintDocumentPage: function (documentNo) {
      let printDocumentURL = `/Home/${this.$route.params.user}/FINAR/`;
      if (this.pageTitle === 'Invoice') {
        printDocumentURL += 'Print Invoice';

        if (documentNo) {
          printDocumentURL += `?invno=${documentNo.trim?.() ?? ''}`;
        }
      } else {
        printDocumentURL += 'Print Debit Note';

        if (documentNo) {
          printDocumentURL += `?dnno=${documentNo.trim?.() ?? ''}`;
        }
      }

      const resolvedPrintDocumentRoute = this.$router.resolve(printDocumentURL);
      window.open(resolvedPrintDocumentRoute.href, '_blank'); // open in a new tab
    },
    clearDocumentData: function () {
      this.documents['docName'] = '';
      this.documents['remarks'] = '';
      this.documents['attachmentFile'] = [];
      this.documents['docGuid'] = '';
      this.documents['filetype'] = '';
      this.documents['docID'] = '';
      // this.$refs['docFile'].clearAttachmentClicked();
      this.showDocDetails = false;
      this.docEditIndex = -1;
      this.selectedDoc = [];
    },
    selectedBillCustomerIsSelected: async function (val) {
      if (val) {
        if (this.newJobChargesDetailsList.length > 0) {
          if (val['Customer Code'] != this.newJobChargesDetailsList[0]['Billing Customer']) {
            await this.$showAlert(
              'error',
              'Unable to change Billing Customer',
              `You have added record for Billing Customer ${this.newJobChargesDetailsList[0]['Billing Customer']}`,
            );
            this.selectedBillCustomer = this.header['billingCustList'].getSelected(
              this.newJobChargesDetailsList[0]['Billing Customer'],
              'Customer Code',
            );
            return;
          }
        }

        this.selectedBillCustomer = val;
        this.filterDate = true;
        this.header['creditTerm'] = '';
        // this.header['jobno'] = '';
        // this.isUsingJobHeader = false;
        // this.selectedFilterJobNoConfirmStr = '';
        // this.selectedFilterJobNoConfirm = [];
        if (!this.advCollection) {
          this.$nextTick(() => {
            this.selectedCreditType =
              this.header['creditTypeList'].find(
                (item) => item['Credit Type'] == this.selectedBillCustomer['Credit Type'],
              ) ?? null;
            this.header['creditTerm'] = this.selectedBillCustomer['Credit Term'].toString();
          });
        } else {
          this.selectedCreditType = this.header['creditTypeList'].find((obj) => obj['Credit Type'] == 'C');
          this.header['creditTerm'] = '0';
        }
        this.internalCustomer = this.selectedBillCustomer?.['Internal Customer'] ?? '0';
        if (this.header['jobno'] != '') {
          // this.jobnoList = await this.$apiCallV2(`/ARInvoice/GetQueryByJobConfig`,  {doctype: this.pageType !== 'Debit' ? 'I' : 'D', jobtypeid: this.jobtypeid.toString(), table: 'JOB', top: this.rowLimitInputValue, jobno: this.header['jobno'], billcu_no: val['Customer Code'] }); //get the specific job
          if (this.jobnoList.length == 0) {
            this.$showAlert('error', 'No Record Found', 'Please select a valid Job No.');
            return;
          }
        }
        if (this.selectedChargesCode) {
          this.taxCodeRate = {
            srvTaxRate: '0',
            sstTaxCode:
              this.internalCustomer != '0' && this.selectedBillCustomer?.['Default SST Tax Code'] != '' ?
                this.selectedBillCustomer?.['Default SST Tax Code']
              : '',
            SASEnableTaxCode: this.SASEnableTaxCode,
            SASEnableTaxRate: this.SASEnableTaxRate,
          };
          this.selectedChargesCodeIsSelect(this.selectedChargesCode);
        }
        this.refreshClicked('');
      }
    },
    clearAllData: function () {
      this.popupTitle = '';
      this.advCollection = false;
      this.newJobChargesDetailsList = [];
      this.deletedNewJobChargesDetailsList = [];
      this.deletedDocumentsList = [];
      this.newSubDetailsList = [];
      this.selectedCreditType = null;
      this.header['creditTerm'] = '';
      this.createdBy = '';
      this.updatedBy = '';
      this.successMessages = [];
      this.headerSelectedCurrency = null;
      this.header['invoiceDate'] = null;
      this.header['InvoiceNo'] = '';
      this.finalBill = true;
      this.header['invoiceRem1'] = '';
      this.header['jobno'] = '';
      this.isUsingJobHeader = false;
      this.selectedFilterJobNoConfirmStr = '';
      this.selectedFilterJobNoConfirm = [];
      this.header['invoiceRem2'] = '';
      this.header['invoiceRem3'] = '';
      this.selectedBillCustomer = null;
      this.selectedInvoiceTypeList = null;
      this.arInvoice['SalesTeam'] = [];
      this.arInvoice['Offset'] = [];
      this.eInvoiceList = [];
      this.glEntry = [];
      this.selectedSalesTeamList = null;
      this.selectedSalesPersonList = null;
      this.totalInWords = '';
      this.totalAmt = '';
      this.outstandingAmt = '';
      this.ftotalAmt = '';
      this.foutstandingAmt = '';
      this.selectedSubDetails = [];
      this.companyName = '';
      this.companyTIN = '';
      this.companyRegNo = '';
      (this.defaultAddressData['addressLine1'] = ''),
        (this.defaultAddressData['addressLine2'] = ''),
        (this.defaultAddressData['addressLine3'] = ''),
        (this.defaultAddressData['addressLine4'] = ''),
        (this.defaultAddressData['postcode'] = ''),
        (this.defaultAddressData['city'] = ''),
        (this.defaultAddressData['state'] = ''),
        (this.defaultAddressData['country'] = ''),
        (this.documentsList = []),
        (this.deletedDocumentsList = []);
      (this.selectedDoc = []),
        (this.reportHdrCheck = false),
        (this.showInfoFromJob = false),
        (this.selectedJobInfo = null),
        (this.showFromTemplate = false),
        (this.leftSideText = '');
      this.rightSideText = '';
      this.gweight = '';
      this.measurement = '';
      this.commodity = '';
      this.currentTabIndex = 0;
      this.header['creditTypeStr'] = '';
      this.clearErrMessage();
      this.clearChargesDetails();
      this.multiCurr = false;
    },
    clearErrMessage: function () {
      this.requiredError = [];
      this.errorMessages = [];
      this.invoiceTypeErr = '';
      this.dataTimeErr = '';
      this.currErr = '';
      this.billCustErr = '';
      this.companyNameErr = '';
      this.creditTypeErr = '';
      this.creditTermErr = '';
      this.exchErr = '';
      this.deleteInvoiceErr = '';
      this.selectedChargesCodeErr = '';
      this.itemNoteErr = '';
      this.fromDateErrorMessage = '';
      this.toDateErrorMessage = '';
      this.fromInvoiceListingDateErr = '';
      this.toInvoiceListingDateErr = '';
      this.searchByErrorMessage = '';
      this.searchCriteriaErrorMessage = '';
      this.searchInputErrorMessage = '';
      this.gweightErrMessage = '';
      this.measurementErrMessage = '';
      this.payeeCodeError = '';
      this.payeeTypeError = '';
      this.selectedUpdatedInvoiceTypeListErrMessage = '';
    },
    clearChargesDetails: function () {
      this.recordSource = false;
      this.foreignDetails = {
        quantity: '',
        uom: null,
        buying: {
          currency: null,
          payeeType: null,
          unitPrice: '',
          totalPrice: 0,
          exchRate: 0,
          payeeCode: null,
        },
        markup: {
          unitPrice: '',
          totalPrice: '',
        },
        selling: {
          currency: null,
          billingCustomer: null,
          unitPrice: '',
          totalPrice: '',
          exchRate: '',
        },
        tax: {
          gsttaxCode: null, //gsttaxcode
          taxRate: '', //gsttaxrate
          taxAmt: '', //gsttaxableamt
          ftaxAmt: '', //gstftaxableamt

          sstTaxCode: null, //gsttaxcode
          srvTaxRate: '', //servicetax
          netInclTax: '', //selling
          fnetInclTax: '', //fselling
          srvTaxAmt: '', //taxableamt
          fsrvTaxAmt: '', //taxableamt
        },
      };
      this.selectedStatusListCategory = [];
      this.itemNote = '';
      this.taxRate = null;
      this.selectedChargesCode = null;
      this.selectedNewJobChargesDetails = [];
      this.selectedGroupCode = null;
      this.freeTextGroupCode = '';
      this.selectedJobno = null;
      this.selectedcontno = null;
      this.selectedCNNO = null;
      this.selectedCostCode = null;
      this.selectedAdjustment = null;
      this.invoiceDesc = '';
      this.invRefNo = '';
      this.documentsList = [];
      this.deletedDocumentsList = [];
      this.selectedDoc = [];
      this.selectedPayeeType = null;
      this.selectedPayeeCode = null;
    },
    handleFileUpload: async function (file) {
      this.$fullscreenLoading('Adding File');
      if (file.length == 0) {
        this.documents['docName'] = '';
        this.documents['filetype'] = '';
        this.documents['attachmentFile'] = [];
      } else {
        this.documents['docName'] = file[0].name;
        this.documents['filetype'] = file[0].name.substring(file[0].name.indexOf('.'));
        const tempAtt = await file[0].toBase64();
        this.documents['attachmentFile'] = tempAtt.substring(tempAtt.indexOf(',') + 1);
        if (this.attachmentsAction == 'edit') {
          this.selectedDoc[0]['File Name'] = file[0].name;
          this.selectedDoc[0]['Doc Image'] = this.documents['attachmentFile'];
          this.newAtt = true;
        }
      }
      this.$fullscreenLoading();
    },
    openSubPackage: async function () {
      if (!this.selectedBillCustomer) {
        await this.$showAlert(
          'warning',
          'No Billing Customer is Selected',
          `Please select Billing Customer to select ${this.pageTitle} Charges from Job Charges`,
        );
        return;
      }
      await this.refreshClicked('');

      this.openJobCharges = true;
      this.openAddNew = false;
    },
    openNewJobCharges: async function (type) {
      if (type == 'add') {
        if (Number(this.header['exchRate']) == 0) {
          this.exchErr = 'Exchange Rate is invalid';
          this.requiredError.push({ key: 'exchErr', value: 'Exchange Rate is invalid!' });
          return;
        }
        this.clearChargesDetails();
        this.clearErrMessage();
        this.addEditChargesTitle = 'New Job Charges';
        this.openJobCharges = false;
        this.openAddNew = true;
        this.selectedAdjustment = this.adjustmentType.find((item) => item['Type'] == 'Adjustment'); //default to Adjustment
        this.$nextTick(() => {
          this.$refs['chargesCode'].setFocus();
          this.taxCodeRate = {
            srvTaxRate: '0',
            sstTaxCode:
              this.internalCustomer != '0' && this.selectedBillCustomer?.['Default SST Tax Code'] != '' ?
                this.selectedBillCustomer?.['Default SST Tax Code']
              : '',
            SASEnableTaxCode: this.SASEnableTaxCode,
            SASEnableTaxRate: this.SASEnableTaxRate,
          };
        });
      } else {
        if (this.selectedNewJobChargesDetails.length == 0) {
          await this.$showAlert(
            'error',
            `No ${this.pageTitle} Selected`,
            `Please select 1 ${this.pageTitle.toLowerCase()} charges to delete`,
          );
          return;
        }
        const data = this.selectedNewJobChargesDetails[0];
        const confirmCancel = await this.$showAlert(
          'warning',
          `Deleting ${this.pageTitle} Charges Record`,
          `Are you sure you want to delete this record ?`,
          [
            { text: 'Yes', color: 'red', textColor: 'white' },
            { text: 'No', color: 'lightgray', textColor: 'black' },
          ],
        );
        if (confirmCancel == 'No') return;

        if (data?.['copy']) {
          const tempSub = this.newSubDetailsList;
          this.newSubDetailsList = [];
          this.selectedSubDetails = [];
          const check = this.tempNewSubDetailsList.filter((item) => item['Txnid'] == data['Txnid']);
          tempSub.push(check[0]); // to return the original object
          this.$nextTick(() => {
            this.newSubDetailsList = tempSub;
          });
        }

        const temp = this.newJobChargesDetailsList;
        this.newJobChargesDetailsList = [];
        if (this.action == 'N') {
          this.$nextTick(() => {
            this.newJobChargesDetailsList = temp.filter((obj) => obj['#'] != data['#']); // left side table // new do not have txnid
          });
        } else {
          temp.forEach((obj) => {
            if (obj['#'] == data['#']) {
              obj['Action'] = 'D';
            }
          });
          const deletedJob = temp.filter((obj) => obj?.Action == 'D');
          this.deletedNewJobChargesDetailsList.push(deletedJob[0]);
          this.$nextTick(() => {
            this.newJobChargesDetailsList = temp.filter((obj) => obj?.Action != 'D');
          });
        }

        this.clearChargesDetails();
        this.clearErrMessage();
      }
    },
    cancelAddNew: function () {
      this.openJobCharges = false;
      this.openAddNew = false;
      this.clearChargesDetails();
    },
    selectAll: function () {
      this.hideSubPackageDetails = false;
      const temp = this.newSubDetailsList;
      this.selectedSubDetails = [];
      this.newSubDetailsList = [];
      temp.forEach((item) => this.selectedSubDetails.push(item));
      this.$nextTick(() => {
        this.newSubDetailsList = temp;
        this.hideSubPackageDetails = true;
      });
    },
    refreshClicked: async function (e) {
      if (!this.pageType) {
        await this.pageChanges();
      }
      if (e == 'Main Page') {
        //to get invoice listing
        let errorInvListing = false;
        if (this.filterDateInvList) {
          if (!this.fromInvoiceListingDate) {
            this.fromInvoiceListingDateErr = 'Enter from date!';
            errorInvListing = true;
          }

          if (!this.toInvoiceListingDate) {
            this.toInvoiceListingDateErr = 'Enter to date!';
            errorInvListing = true;
          }

          if (this.fromInvoiceListingDate.getTime() > this.toInvoiceListingDate.getTime()) {
            this.fromInvoiceListingDateErr = 'From Date > To Date';
            this.toInvoiceListingDateErr = 'From Date > To Date';
            errorInvListing = true;
          }
        }
        if (this.filterSearchInvList) {
          if (!this.searchByValue) {
            this.searchByErrorMessage = 'Select search by!';
            errorInvListing = true;
          }

          if (!this.selectedFilterSearchCriteria) {
            this.searchCriteriaErrorMessage = 'Select search criteria!';
            errorInvListing = true;
          }

          if (!this.searchInputValue.trim()) {
            this.searchInputErrorMessage = 'Enter search value!';
            errorInvListing = true;
          }
        }

        if (errorInvListing) {
          return;
        }

        this.mainFilterIsOpen = false;

        const dataToPost = {
          startdate: this.filterDateInvList ? this.fromInvoiceListingDate.formatString('yyyy-MM-dd') : '',
          enddate: this.filterDateInvList ? this.toInvoiceListingDate.formatString('yyyy-MM-dd') : '',
          txntype: this.pageType !== 'Debit' ? '0' : '1',
          searchfield: this.filterSearchInvList ? this.searchByValue['key'] : '',
          searchcriteria: this.filterSearchInvList ? this.selectedFilterSearchCriteria['name'] : '',
          searchvalue: this.filterSearchInvList ? this.searchInputValue : '',
        };

        const filterItems = [];
        if (this.filterDateInvList) {
          filterItems.push(
            `date from ${this.fromInvoiceListingDate.formatString('yyyy-MM-dd')} to ${this.toInvoiceListingDate.formatString('yyyy-MM-dd')}`,
          );
        }
        if (this.filterSearchInvList) {
          filterItems.push(
            `${this.searchByValue['Search By']} ${this.selectedFilterSearchCriteria['name']} ${this.searchInputValue}`,
          );
        }
        this.filterText = `Filter by ${filterItems.join(', ')}`;
        const tempTitle = this.pageType !== 'Debit' ? 'Getting Invoices' : 'Getting Debit Note';
        this.$fullscreenLoading(tempTitle);
        this.jobTableBoxIsLoading = true;
        this.invoiceListing = [];
        const getInvoice = this.$apiCallV2('/ARInvoice/GetInvoiceListing', dataToPost).then((result) => {
          this.invoiceListing = result;
          this.lastRefreshed = new Date().formatString('yyyy-MM-dd HH:mm');
          this.jobTableBoxIsLoading = false;
          this.$fullscreenLoading();
        }); // start the API call
        this.clearErrMessage();
        return getInvoice;
      }
      let error = false;
      if (this.filterDate) {
        if (!this.fromDate) {
          this.fromDateErrorMessage = 'Enter from date!';
          error = true;
        }

        if (!this.toDate) {
          this.toDateErrorMessage = 'Enter to date!';
          error = true;
        }

        if (this.fromDate.getTime() > this.toDate.getTime()) {
          this.fromDateErrorMessage = 'From Date > To Date';
          this.toDateErrorMessage = 'From Date > To Date';
          error = true;
        }
      }
      if (error) {
        return;
      }

      this.newSubDetailsList = [];
      this.selectedSubDetails = [];
      const oneMonthPrior = new Date();
      oneMonthPrior.setMonth(new Date().getMonth() - 1);
      const dataToFilter = {
        system: 'FINAR',
        jobtypeid: this.jobtypeid ?? '',
        doctype: this.pageType !== 'Debit' ? 'I' : 'D',
        invoicedate: this.header['invoiceDate']?.formatString('yyyy-MM-dd') ?? '',
        billcust: this.selectedBillCustomer?.['Customer Code'] ?? '',
        currency: this.headerSelectedCurrency?.['Currency Code'] ?? '',
        shipperconsignee: this.selectedFilterCngShprConfirmStr ?? '',
        jobno: this.isUsingJobHeader ? this.header['jobno'] : (this.selectedFilterJobNoConfirmStr ?? ''),
        jobdatestart:
          this.isUsingJobHeader ? ''
          : this.filterDate && this.openJobCharges ? this.fromDate?.formatString('yyyy-MM-dd')
          : oneMonthPrior.formatString('yyyy-MM-dd'),
        jobdateend: this.toDate?.formatString('yyyy-MM-dd') ?? new Date().formatString('yyyy-MM-dd'),
        area: this.selectedFilterAreaConfirmStr ?? '',
        sendto: this.selectedFilterSendToConfirmStr ?? '',
        jobtype: '',
        deltype: '',
        dropoff: '',
        projectno: '',
        blno: '',
        bookingrefno: '',
        showcompletedate: 'true',
        showall: 'true',
      };
      this.$fullscreenLoading('Getting Charges from Job Charges');
      let temp = await this.$apiCallV2('/ARInvoice/GetSelectJobCharges', dataToFilter);
      this.newJobChargesDetailsList.forEach((copyItem) => {
        temp = temp.filter((item) => item['Txnid'] != copyItem['Txnid']); //filter added charges
      });
      this.$nextTick(() => {
        this.newSubDetailsList = temp;
        this.fromDate = this.filterDate && this.openJobCharges ? this.fromDate : oneMonthPrior;
      });
      this.$fullscreenLoading();
      if (
        this.filterIsOpen &&
        this.newSubDetailsList.length == 0 &&
        this.headerSelectedCurrency?.['Currency Code'] != 'MYR'
      ) {
        await this.$showAlert(
          'info',
          `There are no Job Charges in currency ${this.headerSelectedCurrency?.['Currency Code']}`,
          ' ',
        );
      }
      this.filterIsOpen = false;
      this.clearErrMessage();
    },
    headerCurrencyFocusChanged: function (newVal, oldVal) {
      if (this.newJobChargesDetailsList.length > 0 && this.action == 'E') {
        this.$showAlert(
          'error',
          `You are not allowed to change the currency`,
          `Currency will remain as ${oldVal['Currency Code']}`,
        );
        this.$nextTick(() => {
          this.headerSelectedCurrency = this.oldCurrency;
          this.currencySelected(this.oldCurrency);
        });
      } else {
        this.headerSelectedCurrency = newVal;
        this.currencySelected(newVal);
      }
    },
    // errorDatePickerCheck: function() {
    //   if (!this.fromInvoiceListingDate && !this.toInvoiceListingDate) {
    //     this.fromInvoiceListingDateErr = 'Please choose a From Date';
    //     this.toInvoiceListingDateErr = 'Please choose a To Date';
    //     return true;
    //   }

    //   if (!this.fromInvoiceListingDate) {
    //     this.fromInvoiceListingDateErr = 'Please choose a From Date';
    //     return true;
    //   }

    //   if (!this.toInvoiceListingDate) {
    //     this.toInvoiceListingDateErr = 'Please choose a To Date';
    //     return true;
    //   }

    //   if (this.fromInvoiceListingDate.getTime() > this.toInvoiceListingDate.getTime()) {
    //     this.fromInvoiceListingDateErr = 'From Date > To Date';
    //     this.toInvoiceListingDateErr = 'From Date > To Date';
    //     return true;
    //   }
    //   return false;
    // },
    currencySelected: function (curr, rate) {
      this.header['exchRate'] =
        this.newJobChargesDetailsList.length > 0 && this.action == 'E' ? Number(this.oldRate).toFixed(4).toString()
        : rate ? Number(rate).toFixed(4).toString()
        : Number(curr['Currency Rate']).toFixed(4).toString();
      this.header['currFactor'] = curr['Factor'];
      this.exchErr = '';
    },
    rptHdrChange: function () {
      this.selectedHeaderDesc = null;
      this.showInfoFromJob = false;
      this.showFromTemplate = false;
    },
    radioChanged: function (e) {
      this.reportHdrCheck = true;
      switch (e['label']) {
        case 'Show info from Job':
          this.showInfoFromJob = true;
          this.showFromTemplate = false;
          break;
        case 'Show info from template':
          if (this.leftSideText == '' || this.rightSideText == '') {
            this.leftSideText = this.leftSideTextDefault;
            this.rightSideText = this.rightSideTextDefault;
          }
          this.showInfoFromJob = false;
          this.showFromTemplate = true;
          break;
      }
    },
    advCollectionChecked: function (checked) {
      const oriCreditTypeVal = this.selectedCreditType;
      const oriCreditTermVal = this.header['creditTerm'];
      if (checked) {
        this.finalBill = false;
        this.selectedCreditType = this.header['creditTypeList'].find((obj) => obj['Credit Type'] == 'C');
        this.header['creditTerm'] = '0';
      } else {
        this.selectedCreditType =
          this.selectedBillCustomer ?
            this.header['creditTypeList'].find(
              (item) => item['Credit Type'] == this.selectedBillCustomer['Credit Type'],
            )
          : null;
        this.header['creditTerm'] = this.selectedBillCustomer?.['Credit Term'].toString() ?? '';
      }
      if (oriCreditTypeVal !== this.selectedCreditType || oriCreditTermVal !== this.header['creditTerm']) {
        const typeChanged = oriCreditTypeVal !== this.selectedCreditType;
        const termChanged = oriCreditTermVal !== this.header['creditTerm'];

        const message =
          typeChanged && termChanged ?
            'Credit Type and Credit Term have changed'
          : 'Credit Type or Credit Term has changed';

        this.$showAlert('info', message, ' ');
      }
    },
    filterCngShprConfirm: function (items) {
      this.selectedFilterCngShprConfirm = items;
      const cngShprList = items.map((obj) => obj['Bill To']);
      this.selectedFilterCngShprConfirmStr = cngShprList.join(',');
    },
    filterJobNoConfirm: function (items) {
      this.selectedFilterJobNoConfirm = items;
      const jobNo = items.map((obj) => obj['Job No']);
      this.selectedFilterJobNoConfirmStr = jobNo.join(',');
    },
    filterAreaConfirm: function (items) {
      this.selectedFilterAreaConfirm = items;
      const areas = items.map((obj) => obj['Area Code']);
      this.selectedFilterAreaConfirmStr = areas.join(',');
    },
    filterSendToConfirm: function (items) {
      this.selectedFilterSendToConfirm = items;
      const sendTo = items.map((obj) => obj['Destination Code']);
      this.selectedFilterSendToConfirmStr = sendTo.join(',');
    },
    convertThreeDigit: function (num) {
      // Function to convert a three-digit number to words
      // Array of words representing numbers from 0 to 19
      const words = [
        '',
        'ONE',
        'TWO',
        'THREE',
        'FOUR',
        'FIVE',
        'SIX',
        'SEVEN',
        'EIGHT',
        'NINE',
        'TEN',
        'ELEVEN',
        'TWELVE',
        'THIRTEEN',
        'FOURTEEN',
        'FIFTEEN',
        'SIXTEEN',
        'SEVENTEEN',
        'EIGHTEEN',
        'NINETEEN',
      ];

      // Array of words representing multiples of 10 from 20 to 90
      const tens = ['', '', 'TWENTY', 'THIRTY', 'FORTY', 'FIFTY', 'SIXTY', 'SEVENTY', 'EIGHTY', 'NINETY'];

      if (num == 0) return '';

      const hundreds = Math.floor(num / 100);
      const remainder = num % 100;

      let result = '';
      if (hundreds > 0) {
        result += words[hundreds] + ' HUNDRED ';
      }

      if (remainder > 0) {
        if (remainder < 20) {
          result += words[remainder];
        } else {
          const tensDigit = Math.floor(remainder / 10);
          const onesDigit = remainder % 10;
          result += tens[tensDigit];
          if (onesDigit > 0) {
            result += '-' + words[onesDigit];
          }
        }
      }

      return result.trim();
    },
    convertToWords: function (num) {
      // Function to recursively convert a number to words
      // Array of words representing powers of 10 (e.g., thousand, million, billion)
      const scales = ['', 'THOUSAND', 'MILLION', 'BILLION', 'TRILLION', 'QUADRILLION'];
      if (num == 0) return 'ZERO';

      let result = '';
      let scaleIndex = 0;

      while (num > 0) {
        const threeDigits = num % 1000;
        if (threeDigits > 0) {
          result = this.convertThreeDigit(threeDigits) + ' ' + scales[scaleIndex] + ' ' + result;
        }
        num = Math.floor(num / 1000);
        scaleIndex++;
      }

      return result.trim();
    },
    attEditButtonClicked: async function (_btn, data) {
      this.selectedDoc = [data];
      await this.projectAttachment({
        // display file retrieved from table
        'File Name': data ? data['File Name'] : '',
        'MIME Type': null,
        'File Data': data ? data['Doc Image'] : '',
      });
    },
    editButtonClicked: async function (_btn, data) {
      if (this.viewMode) return;
      this.clearChargesDetails();
      this.selectedNewJobChargesDetails = [data];
      this.addEditChargesTitle = 'Edit Job Charges';
      await this.populateJobCharges(data);
      this.openAddNew = true;
      this.openJobCharges = false;
      this.clearErrMessage();
    },
    payeeTypeSelected: async function (e, code) {
      this.payeeCodeList =
        e ? await this.$apiCallV2('/Master/GetDetailsMaster', { masterfile: 'payeecode', recordid: e['Table'] }) : [];
      this.selectedPayeeCode = null;
      if (this.payeeCodeList.length > 0) {
        const codeKeys = Object.keys(this.payeeCodeList[0]);
        this.payeeCodeKey = codeKeys[0];
        this.payeeCodeDesc = codeKeys[1];
      }
      this.selectedPayeeCode = this.payeeCodeList.find((i) => {
        return i[this.payeeCodeKey] == code;
      });
      this.selectedPayeeType = e;
    },
    populateJobCharges: async function (val) {
      this.$fullscreenLoading('Populating Charges');
      this.jobnoList = await this.$apiCallV2(`/ARInvoice/GetQueryByJobConfig`, {
        doctype: this.pageType !== 'Debit' ? 'I' : 'D',
        jobtypeid: this.jobtypeid.toString(),
        table: 'JOB',
        top: this.rowLimitInputValue,
        jobno: val['Job No'],
        billcu_no: this.selectedBillCustomer?.['Customer Code'],
      }); //get the specific
      this.chargesDetailsIndex = this.newJobChargesDetailsList.map((n) => n['#']).indexOf(val['#']);
      const check = this.groupCodeList.find((item) => item['Charges Code'] == val['Group Code']);
      if (check) {
        this.selectedGroupCode = check;
      } else {
        this.selectedGroupCode = null;
        this.$nextTick(() => {
          this.freeTextGroupCode = val['Group Code'] ?? '';
        });
      }
      this.selectedChargesCode =
        this.chargesCodeList.length > 0 ?
          this.chargesCodeList.find((item) => item['Charge Code'] == val['Charges Code'])
        : null;
      const changeResult = await this.$apiCallV2('/ARInvoice/ArInvoiceChargeCodeChange', {
        chargecode: val['Charges Code'],
        invdate: this.header['invoiceDate'].formatString('yyyy-MM-dd'),
        costcode: this.selectedCostCode?.['Cost Code'],
        billto: this.selectedBillCustomer['Customer Code'] ?? '',
        internalcust: this.selectedBillCustomer?.['Internal Customer'] ?? '0',
        gstinvoice: this.selectedInvoiceTypeList?.['Description'].includes('GST') ? '1' : '0',
      });
      this.getTaxCodeRate(changeResult, this.selectedChargesCode);
      this.payableChecking = this.selectedChargesCode?.['Payable'] ?? '1';
      this.selectedJobno =
        this.jobnoList.length > 0 ? this.jobnoList.find((item) => item['Job No'] == val['Job No']) : null;
      if (this.selectedJobno) {
        await this.jobNoIsSelected(this.selectedJobno);
      }
      this.recordSource = !(val['RecordSource'] == '3' || val['RecordSource'] == ''); //val == 3 allow to edit; is disabled false
      this.selectedcontno =
        this.contList.length > 0 ? this.contList.find((item) => item['Cont No'] == val['Cont No']) : null;
      this.selectedCNNO =
        this.consignmentList.length > 0 ?
          this.consignmentList.find((item) => item['Consignment No'] == val['Consignment No'])
        : null;
      this.selectedCostCode =
        this.costCodeList.length > 0 ? this.costCodeList.find((item) => item['Cost Code'] == val['Cost Code']) : null;
      this.selectedAdjustment =
        this.adjustmentType.length > 0 ? this.adjustmentType.find((item) => item['Code'] == val['AdjType']) : null;
      this.invoiceDesc = val['Description'];
      this.itemNote = val['Notes'];
      this.invRefNo = val['Invoice Ref No'];
      const markupUP =
        !val['Mark Up FAmount'] ?
          this.$currencyFormat(Number('0'))
        : Number(val['Mark Up FAmount']) / Number(val['Qty']).toFixed(4);
      this.selectedPayeeType =
        this.payeeTypeList.find((i) => {
          return i['Party Code'] == val['Payee Type'];
        }) ?? null;
      if (this.selectedPayeeType) {
        this.payeeTypeSelected(this.selectedPayeeType, val['Payee Code']);
      }
      this.foreignDetails = {
        quantity: !val['Qty'] ? '' : val['Qty'],
        uom: val['UOM'] ? val['UOM'] : '',
        buying: {
          currency: val['Buying Currency'] ? val['Buying Currency'] : this.headerSelectedCurrency['Currency Code'],
          unitPrice: !val['Buying Unit Price'] ? '' : val['FBuying Unit Price'],
          totalPrice: !val['Buying Famount'] ? '' : val['Buying Famount'],
          exchRate: val['Buying Rate'] ? val['Buying Rate'].toString() : this.header['exchRate'].toString(),
        },
        markup: {
          unitPrice: markupUP.toString(),
          totalPrice: !val['Mark Up FAmount'] ? '' : val['Mark Up FAmount'],
        },
        selling: {
          currency: val['Currency'] ? val['Currency'] : this.headerSelectedCurrency['Currency Code'],
          unitPrice: !val['Selling FUnit Price'] ? '' : val['Selling FUnit Price'],
          totalPrice: !val['Selling FTotal'] ? '' : val['Selling FTotal'],
          exchRate: !val['Selling Rate'] ? this.header['exchRate'].toString() : val['Selling Rate'].toString(),
        },
        tax: {
          taxRate: val['Tax Rate'] ? val['Tax Rate'] : '0',
          taxAmt: val['Tax Famt'] ? val['Tax Famt'] : '0',
          ftaxAmt: val['Tax FAmount'] ? val['Tax FAmount'] : '0',
          gsttaxCode: val['Tax Code'] ? val['Tax Code'] : '0',

          taxCode: val['Tax Code'] ? val['Tax Code'] : '',
          srvTaxRate: val['Srv Tax Rate'] ? val['Srv Tax Rate'] : '0',
          netInclTax: val['Selling Amount'] ? val['Selling Amount'] : '0.00',
          fnetInclTax: val['Selling FAmount'] ? val['Selling FAmount'] : '0.00',
          srvTaxAmt: val['Srv Tax Amount'] ? val['Srv Tax Amount'] : '0',
          fsrvTaxAmt: val['Srv Tax FAmount'] ? val['Srv Tax FAmount'] : '0',
        },
      };
      this.$fullscreenLoading();
    },
    convertCurrencyToWords: function (cur) {
      // Split currency into whole and fractional parts

      const parts = cur.split('.');
      const wholePart = parseInt(parts[0]);
      const fractionalPart = parseInt(parts[1]) || 0;

      // Convert whole part to words
      const wholeWords = this.convertToWords(wholePart);
      const fractionalWords = this.convertToWords(fractionalPart);

      // Construct the final result
      const currName = this.headerSelectedCurrency?.['Description'] ?? 'MALAYSIAN RINGGIT';
      let result = currName + ' ' + wholeWords;
      if (fractionalPart > 0) {
        result += ' AND ' + fractionalWords + ' CENTS';
      }

      return result + ' ONLY';
    },
    calculateTotalInvoice: function (val) {
      let totalAmt = '';
      let ftotalAmt = '';
      let offsetAmt = 0;
      let fOffsetAmt = 0;
      totalAmt =
        val.length == 0 ?
          0
        : val
            .map((data) => {
              return Number(data['Selling Amount']);
            })
            .reduce((a, b) => {
              return a + b;
            });
      ftotalAmt =
        val.length == 0 ?
          0
        : val
            .map((data) => {
              return Number(data['Selling FAmount']);
            })
            .reduce((a, b) => {
              return a + b;
            });

      this.totalAmt = this.$currencyFormat(totalAmt);
      this.ftotalAmt = this.$currencyFormat(ftotalAmt);
      if (this.offsetDocList.length > 0) {
        offsetAmt = this.offsetDocList
          .map((data) => {
            return Number(data['Offset Amount']);
          })
          .reduce((a, b) => {
            return a + b;
          })
          .toFixed(4);
        fOffsetAmt = (
          (Number(offsetAmt) * Number(this.header['exchRate'])) /
          Number(this.header['currFactor'])
        ).toFixed(4);
        this.outstandingAmt = this.$currencyFormat(parseFloat(totalAmt) - parseFloat(offsetAmt));
        this.foutstandingAmt = this.$currencyFormat(parseFloat(ftotalAmt) - parseFloat(fOffsetAmt));
      } else {
        this.outstandingAmt = this.$currencyFormat(totalAmt);
        this.foutstandingAmt = this.$currencyFormat(ftotalAmt);
      }
      this.totalInWords = this.convertCurrencyToWords(this.totalAmt.toString());
    },
    getIndicatorName: function (key, value, type) {
      const item = this.summaryItem.find((item) => item.Title === key);

      if (item && item.Indicator) {
        const indicator = item.Indicator.find((indicator) => indicator.code === value);

        if (indicator) {
          return type == 'title' ? indicator.name : indicator.bg;
        }
      }
      return item?.Indicator?.[0]?.name || null;
    },
    jobNoIsSelected: async function (val) {
      if (val) {
        if (!this.selectedBillCustomer) {
          this.selectedBillCustomer = this.header['billingCustList'].find((bill) => {
            return bill['Customer Code'] == val['Billing Customer'];
          });
        }

        if (
          val['Billing Customer'] != this.selectedBillCustomer?.['Customer Code'] &&
          this.selectedNewJobChargesDetails.length == 0
        ) {
          const confirmInvalidJob = await this.$showAlert(
            'error',
            `Invalid Job No for this Customer ${val['Billing Customer']}!`,
            `Job Billing Customer: ${this.selectedBillCustomer['Customer Code']}\nDo you want to use this Job No ?`,
            [
              { text: 'Yes', color: 'red', textColor: 'white' },
              { text: 'No', color: 'lightgray', textColor: 'black' },
            ],
          );

          if (confirmInvalidJob == 'No') {
            this.selectedJobno = null;
            return;
          }
        }

        this.$fullscreenLoading('Getting Container List');
        this.contList = await this.$apiCallV2(`/ARInvoice/GetQueryByJobConfig`, {
          doctype: this.pageType !== 'Debit' ? 'I' : 'D',
          jobtypeid: this.jobtypeid?.['JobTypeID'],
          table: 'CONTAINER',
          jobno: val['Job No'],
        });
        this.$fullscreenLoading('Getting Consignment List');
        this.consignmentList = await this.$apiCallV2(`/ARInvoice/GetQueryByJobConfig`, {
          doctype: this.pageType !== 'Debit' ? 'I' : 'D',
          jobtypeid: this.jobtypeid?.['JobTypeID'],
          table: 'CONSIGNMENT',
          jobno: val['Job No'],
        });
        this.$fullscreenLoading();
      }
    },
    filterSearchIsClicked: function (val) {
      if (!val) {
        this.selectedFilterJobNoConfirm = this.isUsingJobHeader ? this.selectedFilterJobNoConfirm : [];
        this.selectedFilterJobNoConfirmStr = this.isUsingJobHeader ? this.selectedFilterJobNoConfirmStr : '';
        this.selectedFilterAreaConfirm = [];
        this.selectedFilterAreaConfirmStr = '';
        this.selectedFilterSendToConfirm = [];
        this.selectedFilterSendToConfirmStr = '';
        this.selectedFilterCngShprConfirm = [];
        this.selectedFilterCngShprConfirmStr = '';
      }
    },
    tabClicked: async function (_tabItem, tabIndex) {
      if (this.openAddNew && this.selectedChargesCode && tabIndex != 0) {
        const checking = await this.$showAlert(
          'warning',
          `Charge item not added yet`,
          `Do you wish to discard the changes?`,
          [{ text: 'Discard', color: 'Red', textColor: 'white' }, { text: 'Cancel' }],
        );
        if (checking === 'Cancel') {
          return;
        }
        this.$nextTick(() => {
          this.clearChargesDetails();
        });
      }

      //auto select the report header description in edit mode.
      this.$nextTick(() => {
        this.currentTabIndex = tabIndex;
        if (this.action == 'E' && tabIndex == 1) {
          if ((this.leftSideText || this.rightSideText) && this.showFromTemplate) {
            this.selectedHeaderDesc = this.headerDescRadioButtons[1];
            this.reportHdrCheck = true;
            this.showFromTemplate = true;
            this.showInfoFromJob = false;
          } else if (this.selectedJobInfo || this.selectedHeaderDesc?.['keyValue'] == '1') {
            this.selectedHeaderDesc = this.headerDescRadioButtons[0];
            this.reportHdrCheck = true;
            this.showInfoFromJob = true;
            this.showFromTemplate = false;
          } else {
            this.leftSideText = this.leftSideTextDefault;
            this.rightSideText = this.rightSideTextDefault;
            this.showInfoFromJob = false;
            this.showFromTemplate = false;
          }
        }
      });
    },
    getTaxCodeRate: function (changeResult, val) {
      this.taxCodeRate = {
        srvTaxRate:
          this.internalCustomer != '0' ? '0'
          : this.selectedBillCustomer?.['Default SST Tax Code'] != '' ?
            this.selectedBillCustomer?.['Default SST Tax Rate']?.toString()
          : changeResult['SSTExemptCode'] != '' ? changeResult['ExemptRate']
          : val['SST Rate %'].toString(),

        sstTaxCode:
          this.internalCustomer != '0' ? ''
          : this.internalCustomer == '0' && this.selectedBillCustomer?.['Default SST Tax Code'] != '' ?
            this.selectedBillCustomer?.['Default SST Tax Code']
          : changeResult['SSTExemptCode'] != '' ? changeResult['SSTExemptCode']
          : '',
        SASEnableTaxCode: this.SASEnableTaxCode,
        SASEnableTaxRate: this.SASEnableTaxRate,
      };
    },
    selectedChargesCodeIsSelect: async function (val) {
      if (val) {
        this.payableChecking = val['Payable'];
        const changeResult = await this.$apiCallV2('/ARInvoice/ArInvoiceChargeCodeChange', {
          chargecode: val['Charge Code'],
          invdate: this.header['invoiceDate'].formatString('yyyy-MM-dd'),
          costcode: this.selectedCostCode?.['Cost Code'],
          billto: this.selectedBillCustomer?.['Customer Code'] ?? '',
          internalcust: this.selectedBillCustomer?.['Internal Customer'] ?? '0',
          gstinvoice: this.selectedInvoiceTypeList?.['Description'].includes('GST') ? '1' : '0',
        });
        this.getTaxCodeRate(changeResult, val);
        if (changeResult) {
          if (changeResult['groupcode']) {
            this.selectedGroupCode = this.groupCodeList.getSelected(changeResult['groupcode'], 'Charges Code');
            this.freeTextGroupCode = changeResult['groupcode'];
          }
          if (changeResult['costcode']) {
            this.selectedCostCode = this.costCodeList.getSelected(changeResult['costcode'], 'Cost Code');
          }
        }
        this.invoiceDesc = val['Description'];
        if (this.selectedSubDetails.length == 0) {
          this.$refs['foreignCurrency'].calculateTax();
        }
      } else {
        this.selectedGroupCode = null;
        this.freeTextGroupCode = '';
        this.selectedCostCode = null;
        this.invoiceDesc = '';
      }
    },
    checkDetCurr: function () {
      if (this.newJobChargesDetailsList.length > 0) {
        let tempDetList = [];
        tempDetList = [...new Set(this.newJobChargesDetailsList.map((item) => item['Currency']))];

        return tempDetList.length;
      }
      return 0;
    },
    rateValueChanged: async function (val) {
      // CONDITION TO AUTO CHANGE THE DETAILS RATE on lost focus
      // Foreign currency for header
      const sameWithDet =
        this.newJobChargesDetailsList.length > 0 ?
          this.header['exchRate'] == this.newJobChargesDetailsList[0]['Selling Rate']
        : false;
      if (
        !val &&
        this.newJobChargesDetailsList.length > 0 &&
        !sameWithDet &&
        this.headerSelectedCurrency['Currency Code'] != 'MYR'
      ) {
        const confirm = await this.$showAlert(
          'warning',
          'Header Exch. Rate Changed',
          `Are you sure you want to change all ${this.pageTitle.toLowerCase()} Exch. Rate?`,
          [
            { text: 'Yes', color: 'red', textColor: 'white' },
            { text: 'No', color: 'lightgray', textColor: 'black' },
          ],
        );

        if (confirm == 'Yes') {
          //recalculate selling section based on the new rate
          const temp = this.newJobChargesDetailsList;
          this.newJobChargesDetailsList = [];
          this.$nextTick(() => {
            this.newJobChargesDetailsList = temp.map((invoice) => {
              const tempSellTotP = (
                (Number(invoice['Selling FTotal']) * Number(this.header['exchRate'])) /
                Number(this.headerSelectedCurrency['Factor'])
              ).toFixed(4);
              if (invoice['Selling Rate']) {
                invoice['Selling Rate'] = this.header['exchRate'];
                const tempSellUP = (
                  (Number(invoice['Selling FUnit Price']) * Number(this.header['exchRate'])) /
                  Number(this.headerSelectedCurrency['Factor'])
                ).toFixed(4);
                const tempSellingTot = Number(tempSellTotP) + Number(invoice['Srv Tax Amount']);
                invoice['Selling Unit Price'] = tempSellUP.toString();
                invoice['Srv Tax Amount'] = ((Number(invoice['Srv Tax Rate']) / 100) * tempSellTotP)
                  .toFixed(2)
                  .toString();
                invoice['Selling Amount'] = tempSellingTot.toString();
              } else {
                invoice['Selling Rate'] = this.header['exchRate'];
                const tempSellUP = (
                  (Number(invoice['Selling FUnit Price']) * Number(this.header['exchRate'])) /
                  Number(this.headerSelectedCurrency['Factor'])
                ).toFixed(4);
                const tempSellingTot = Number(tempSellTotP) + Number(invoice['Srv Tax Amount']);
                invoice['Selling Unit Price'] = tempSellUP.toString();
                invoice['Srv Tax Amount'] = ((Number(invoice['Srv Tax Rate']) / 100) * tempSellTotP)
                  .toFixed(2)
                  .toString();
                invoice['Selling Amount'] = tempSellingTot.toString();
              }
              invoice['Selling Total'] = tempSellTotP.toString();
              return invoice;
            });
            //repopulating selected data
            const updatedSelected = this.newJobChargesDetailsList.find(
              (item) => item['Txnid'] == this.selectedNewJobChargesDetails[0]['Txnid'],
            );
            this.selectedNewJobChargesDetails = [updatedSelected];
            this.clearChargesDetails();
            this.populateJobCharges(updatedSelected);
          });
        } else {
          this.header['exchRate'] = this.oldRate;
        }
      } else if (
        (!val &&
          this.checkDetCurr() == 1 &&
          this.headerSelectedCurrency['Currency Code'] == 'MYR' &&
          this.header['exchRate'] != Number(this.headerSelectedCurrency['Currency Rate']).toFixed(4).toString()) ||
        (!val &&
          this.newJobChargesDetailsList.length == 0 &&
          this.headerSelectedCurrency['Currency Code'] == 'MYR' &&
          this.header['exchRate'] != Number(this.headerSelectedCurrency['Currency Rate']).toFixed(4).toString())
      ) {
        //should fix to 1
        this.$showAlert(
          'error',
          `You are not allowed to change the Exchange Rate`,
          `Exchange Rate will remain as 1.000`,
        );
        this.$nextTick(() => {
          this.header['exchRate'] = Number(this.headerSelectedCurrency['Currency Rate']).toFixed(4).toString();
        });
      }

      this.header['exchRate'] = Number(this.header['exchRate']).toFixed(4).toString();
    },
    rowLimitInputValueChanged: async function (focus) {
      if (!focus) {
        this.$fullscreenLoading('Getting Job No');
        this.jobnoList = [];
        this.jobnoList = await this.$apiCallV2(`/ARInvoice/GetQueryByJobConfig`, {
          doctype: this.pageType !== 'Debit' ? 'I' : 'D',
          jobtypeid: this.jobtypeid.toString(),
          table: 'JOB',
          top: this.rowLimitInputValue,
        });
        this.$fullscreenLoading();
      }
    },
    pageChanges: async function (to) {
      this.showPopup = false;
      this.pageTitle = '';
      let pageRoute;
      if (to) {
        pageRoute = to.path.split('/');
      } else {
        pageRoute = this.$route.path.split('/');
      }
      this.pageType = pageRoute[pageRoute.length - 1].split(' ')[0];
      this.pageTitle = pageRoute[pageRoute.length - 1];
      this.menu.forEach((m) => {
        m.enabled = true;
        m.visible = true;
        // if (i <= 4) {
        if (
          m.title.startsWith('New') ||
          m.title.startsWith('Edit') ||
          m.title.startsWith('Delete') ||
          m.title.startsWith('View') ||
          m.title.startsWith('Print')
        ) {
          m.title = `${m.title.split(' ')[0]} ${this.pageTitle}`;
          // } else if (i == 5) {
          //   m.title = `Copy Current ${this.pageTitle}`;
          // } else if (i == 6) {
        } else if (m.title.startsWith('Update')) {
          m.title = `Update ${this.pageTitle} Type`;
        } else if (m.title === 'Unauthorize') {
          m.visible = false;
        }
      });

      this.tabsItems.forEach((m, i) => {
        if (i == 0) {
          m.title = `${this.pageTitle} Charges`;
        }
      });

      if (to) {
        this.invoiceListing = [];
        this.$nextTick(() => {
          setTimeout(() => {
            this.refreshClicked('Main Page');
          }, 500);
        });
      }

      this.SASEnableTaxCode = true;
      this.SASEnableTaxRate = true;
      const sasControl = await this.$apiCallV2(`/SASControl/GetSASControlAccess?system=FINAR&page=${this.pageTitle}`);
      sasControl.forEach((k) => {
        if (k.Control === 'TxtTaxCode' && k.Properties === 'Enabled') {
          this.SASEnableTaxCode = k.PropertiesValue === 'True';
        }
        if (k.Control === 'TxtTaxRate' && k.Properties === 'Enabled') {
          this.SASEnableTaxRate = k.PropertiesValue === 'True';
        }
        //key in menu same as control value from api
        const selectedMenu = this.menu.find((m) => m['key'] == k['Control']);
        if (selectedMenu) {
          selectedMenu[k['Properties'].toLowerCase()] = k['PropertiesValue'] == 'True';
        }
      });
      await this.$nextTick();
    },
    updateDocTypePopupClicked: async function (e) {
      switch (e) {
        case 'Update': {
          if (!this.selectedUpdatedInvoiceTypeList) {
            this.selectedUpdatedInvoiceTypeListErrMessage = 'Please select an Invoice Type';
            return;
          }
          this.clearErrMessage();
          this.$fullscreenLoading(`Updating Selected ${this.pageType}`);
          const result = await this.$apiCallV2('/ARInvoice/UpdateDocumentType', {
            docno: this.selectedInvoiceListing[0]['Invoice #'],
            doctype: this.pageType !== 'Debit' ? 'I' : 'D',
            docjobtype: this.selectedUpdatedInvoiceTypeList['JobTypeID'],
          });
          this.$fullscreenLoading();
          this.showUpdateDocType = false;
          this.selectedUpdatedInvoiceTypeList = null;
          if (result[0]['Results'] == '0') {
            this.$showAlert(
              'success',
              'Updated!',
              `${this.pageTitle} ${this.selectedInvoiceListing[0]['Invoice #']} was successfully updated.`,
            );
            this.invoiceListing = [];
            this.selectedInvoiceListing = [];
            this.$nextTick(async () => await this.refreshClicked('Main Page'));
          } else {
            this.$showAlert('error', 'Update unsuccessful', `${result[0]['ErrMsg']}`);
          }
          break;
        }
        case 'Cancel':
          this.clearErrMessage();
          this.showUpdateDocType = false;
          this.selectedUpdatedInvoiceTypeList = null;
          break;
      }
    },
  },
  async mounted() {
    const mountedPromises = [];
    let mountedPromisesFulfilledCount = 0;

    mountedPromises.push(
      this.$apiCallV2('/Login/GetDetails').then((result) => {
        this.userid = result.LoginUserId;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'currency' }).then((result) => {
        this.header['currencyList'] = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CREDITTYPE' }).then((result) => {
        this.header['creditTypeList'] = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'CHARGESCODE', module: 'FINAR' }).then((result) => {
        this.chargesCodeList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/ARInvoice/GetJobTypeConfig', { doctype: this.pageType !== 'Debit' ? 'I' : 'D' }).then(
        (result) => {
          this.header['invoiceTypeList'] = result;
          this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
        },
      ),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'COSTCODE' }).then((result) => {
        this.costCodeList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'GROUPCODE' }).then((result) => {
        this.groupCodeList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'postcode' }).then((result) => {
        this.postcodeList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'state' }).then((result) => {
        this.stateList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'country' }).then((result) => {
        this.countryList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'area' }).then((result) => {
        this.areaDataList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SENDTO_ALL' }).then((result) => {
        this.sendToDataList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'shipper' }).then((result) => {
        this.cngShpDataList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'COMPANY' }).then((result) => {
        this.companyList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'STATUSLISTCATEGORY' }).then((result) => {
        this.statusListCategory = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SALESTEAM', module: 'FINAR' }).then((result) => {
        this.salesPersonList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SALESPERSON', module: 'FINAR' }).then((result) => {
        this.companyList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );
    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'PARTY' }).then((result) => {
        this.payeeTypeList = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetSettingsSystem?settingsitem=FINAR_AdvColConfig').then((result) => {
        this.advColConfig = result[0].SettingsValue;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    await Promise.allSettled(mountedPromises);
    await this.pageChanges();
    this.refreshClicked('Main Page');

    if(this.searchFilterItems.length == 1){
      this.searchByValue = this.searchFilterItems[0];
    }

    if (this.$route.query['invno']) {
      this.filterSearchInvList = true;
      this.filterDateInvList = false;
      this.searchByValue = this.searchFilterItems.getSelected('Invoice #', 'Search By');
      this.selectedFilterSearchCriteria = this.searchCriteriaItems.getSelected('EQUALS', 'name');
      this.searchInputValue = this.$route.query['invno'];
      await this.refreshClicked('Main Page');
      this.selectedInvoiceListing = this.invoiceListing.filter((i) => i['Invoice #'] === this.$route.query['invno']);
      // SAS Control
      const menuTitle = this.$route.query['action'] == 'E' ? `Edit ${this.pageTitle}` : `View ${this.pageTitle}`;
      const selectedMenu = this.menu.getSelected(menuTitle, 'title');
      const sasProperty = this.pageTitle == 'Invoice' ? 'enabled' : 'visible';
      if (!selectedMenu[sasProperty]) {
        this.$showAlert('warning', 'Access Denied', `You do not have permission to ${menuTitle}`);
        return;
      }
      this.$nextTick(() => {
        this.menuClicked({
          title: menuTitle,
        });
      });
    }
  },
  beforeDestroy() {
    // this.$bus.$off('routeChanged'); // stop listening to the event
  },
  watch: {
    // advCollection: function (val) {
    //   const oriCreditTypeVal = this.selectedCreditType;
    //   const oriCreditTermVal = this.header['creditTerm'];
    //   if (val) {
    //     this.selectedCreditType = this.header['creditTypeList'].find((obj) => obj['Credit Type'] == 'C');
    //     this.header['creditTerm'] = '0';
    //   } else {
    //     this.selectedCreditType =
    //       this.selectedBillCustomer ?
    //         this.header['creditTypeList'].find(
    //           (item) => item['Credit Type'] == this.selectedBillCustomer['Credit Type'],
    //         )
    //       : null;
    //     this.header['creditTerm'] = this.selectedBillCustomer?.['Credit Term'].toString() ?? '';
    //   }
    //   if (oriCreditTypeVal !== this.selectedCreditType || oriCreditTermVal !== this.header['creditTerm']) {
    //     const typeChanged = oriCreditTypeVal !== this.selectedCreditType;
    //     const termChanged = oriCreditTermVal !== this.header['creditTerm'];

    //     const message =
    //       typeChanged && termChanged ?
    //         'Credit Type and Credit Term have changed'
    //       : 'Credit Type or Credit Term has changed';

    //     this.$showAlert('info', message, ' ');
    //   }
    // },
    async $route() {
      await this.pageChanges();
    },
    pageTitle: function (val) {
      if (val) {
        this.popupShow = false;
      }
    },
    pageType: async function (newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.$fullscreenLoading(`Getting ${this.pageTitle} Type`);
        this.header['invoiceTypeList'] = await this.$apiCallV2('/ARInvoice/GetJobTypeConfig', {
          doctype: newVal !== 'Debit' ? 'I' : 'D',
        });
        this.$fullscreenLoading();
      }
    },
    selectedJobno: async function (val) {
      if (!val) {
        if (this.selectedPayeeType && this.selectedPayeeCode) {
          await this.$showAlert(
            'warning',
            `Payee Type and Payee Code will be cleared`,
            `Payee details are not applicable if no Job No. is selected.`,
          );
        }
      }
    },
    selectedDoc: function (val) {
      if (val) {
        this.documents['remarks'] = val['Doc Remark'];
      }
    },
    selectedCreditType: function (val) {
      if (val) {
        switch (val['Credit Type']) {
          case 'C':
            this.header['creditTerm'] = '0';
            this.creditTermIsDisabled = true;
            break;
          case 'D':
            this.creditTermIsDisabled = false;
            break;
          case 'M':
            this.creditTermIsDisabled = false;
            break;
          default:
            this.creditTermIsDisabled = false;

            break;
        }
      }
    },
    selectedInvoiceTypeList: async function (val) {
      if (val) {
        this.viewMode = !['N', 'E'].includes(this.action);
        // if(this.action != '' ) {
        // this.creditTermIsDisabled = false;
        // }
        const loadText = this.action == 'N' ? 'Getting Billing Customer' : 'Populating Billing Customer';
        this.$fullscreenLoading(loadText);
        this.jobtypeid = val['JobTypeID'].toString();
        this.header['billingCustList'] = await this.$apiCallV2('/ARInvoice/GetBillingCust', {
          doctype: this.pageType !== 'Debit' ? 'I' : 'D',
          jobtypeid: val['JobTypeID'].toString(),
        });
        if (this.action != 'N') {
          this.selectedBillCustomer = this.header['billingCustList'].find(
            (bill) => bill['Customer Code'].trim() == this.arInvoice['BillCust'],
          );
          this.taxCodeRate = {
            srvTaxRate: '0',
            sstTaxCode:
              this.internalCustomer != '0' && this.selectedBillCustomer?.['Default SST Tax Code'] != '' ?
                this.selectedBillCustomer?.['Default SST Tax Code']
              : '',
            SASEnableTaxCode: this.SASEnableTaxCode,
            SASEnableTaxRate: this.SASEnableTaxRate,
          };
        }
        if (this.action == 'N' && this.advColConfig != '' && val['Description'].toLowerCase().includes(this.advColConfig.toLowerCase())) {
          this.advCollection = true;
          this.advCollectionChecked(this.advCollection);
        }
        this.$fullscreenLoading();
        this.jobLoading = true;
        this.jobnoList = [];
        this.jobnoList = await this.$apiCallV2(`/ARInvoice/GetQueryByJobConfig`, {
          doctype: this.pageType !== 'Debit' ? 'I' : 'D',
          jobtypeid: val['JobTypeID'].toString(),
          table: 'JOB',
          top: this.rowLimitInputValue,
        });
        this.jobLoading = false;
      } else {
        this.viewMode = true;
        this.creditTermIsDisabled = true;
      }
    },
    selectedNewJobChargesDetails: async function (val) {
      if (val.length > 0 && this.action == '') {
        //will auto populate in view mode only
        this.openAddNew = true;
        this.openJobCharges = false;
        await this.populateJobCharges(val[0]);
      }
    },
    selectedBillCustomer: function (val) {
      if (!val) {
        this.header['creditTerm'] = '';
        this.selectedCreditType = null;
        this.header['creditTypeStr'] = '';
      }
    },
    headerSelectedCurrency: function (val) {
      if (!val) {
        this.header['exchRate'] = '';
        this.exchErr = '';
      } else if (
        this.newJobChargesDetailsList.length > 0 &&
        this.action == 'E' &&
        val['Currency Code'] != this.oldCurrency['Currency Code']
      ) {
        this.$showAlert(
          'error',
          `You are not allowed to change the currency`,
          `Currency will remain as ${this.oldCurrency['Currency Code']}`,
        );
        this.$nextTick(() => {
          this.headerSelectedCurrency = this.oldCurrency;
          this.currencySelected(this.oldCurrency);
        });
      }
    },
    newJobChargesDetailsList: {
      deep: true,
      handler(val) {
        if (val) {
          this.jobList = [];
          this.calculateTotalInvoice(val);
          this.multiCurr = !val.every((d) => d['Currency'] == this.headerSelectedCurrency['Currency Code']);
          const tempnewJobChargesDetailsList = val.filter((job) => job['Job No'].trim() != ''); //filter empty job
          let current = '';
          tempnewJobChargesDetailsList.forEach((job) => {
            if (current != job['Job No'].trim()) {
              //filter duplicated job
              current = job['Job No'];
              this.jobList.push({ JobNo: job['Job No'] });
            }
          });
        }
      },
    },
    selectedInvoiceListing: function (val) {
      const authMenu = this.menu.find((f) => f['key'] === 'mnAuthorized');
      const unAuthMenu = this.menu.find((f) => f['key'] === 'mnUnAuthorized');
      if (val.length > 0) {
        authMenu['visible'] = val[0]['Authorized'] !== 'Authorized';
        unAuthMenu['visible'] = val[0]['Authorized'] === 'Authorized';
      } else {
        authMenu['visible'] = true;
        unAuthMenu['visible'] = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';
.arinvoice-main {
  display: flex;
  font-size: 12px;
  padding: 10px 45px;

  > .left-container {
    display: flex;
    justify-content: center;
  }

  > .right-container {
    width: 100%;
    margin-left: 5px;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    > .top-section,
    > .bottom-section {
      background-color: white;
      border-radius: 5px;
      padding: 5px;
    }

    > .top-section {
      display: flex;
      align-items: center;
      justify-content: flex-end;

      > .filter-description {
        padding-right: 8px;
      }

      > .button-filter-component {
        margin-right: 5px;
        position: relative;

        .filter-popup {
          display: flex;
          flex-direction: column;

          > button {
            margin-top: 5px;
            width: fit-content;
            align-self: flex-end;
          }
        }
      }
    }

    > .bottom-section {
      height: calc(100% - 38px - 5px); // deduct height of top-section and margin
      margin-top: 5px;
    }
  }

  > .attachments-popup-container {
    > .attachments-popup {
      ::v-deep {
        // deep needed to target the content class inside the PopupV2 component
        .content {
          // NOT the content class for slot, but content class inside PopupV2 itself
          overflow: visible;
        }
      }

      .attachments-popup-content {
        overflow: visible;

        > .attached-file {
          text-align: left;
          margin-bottom: 8px;

          > .file-link {
            cursor: pointer;
            user-select: none;

            &:hover {
              text-decoration: underline;
            }

            &:active {
              background-color: black;
              color: white;
            }
          }
        }
      }
    }
  }

  > .attachment-projector {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 99999;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    justify-content: center;
    align-items: center;

    > .attachment-projection {
      height: 95%;
      width: 80%;

      > object {
        height: 100%;
        width: 100%;
        object-fit: scale-down;
      }

      > .attachment-not-projectable-container {
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        font-size: 40px;

        > span {
          margin: 10px 0 10px 0;
          color: white;
        }

        > button {
          height: 50px;
          width: 150px;
          margin: 10px 0 10px 0;
          font-size: 16px;

          > img {
            height: 24px;
            width: 24px;
          }
        }
      }
    }

    > .close-button {
      height: 50px;
      width: 50px;
      position: absolute;
      top: 10px;
      right: 10px;
      border-radius: 100px;
      background-color: white;
      text-align: center;
      font-size: xx-large;
      cursor: pointer;
      user-select: none;
    }
  }
}

.summary-row {
  display: flex;
  flex-direction: row;
  width: fit-content;

  > :nth-child(1) {
    margin-right: 5px;
  }
}

.first-section {
  display: flex;
  width: 100%;

  > .left-section {
    display: flex;
    flex-direction: column;
    width: 20%;
    margin-right: 10px;
  }

  > .right-section {
    display: flex;
    flex-direction: column;
    width: 80%;

    > .right-section_top {
      display: flex;
      flex-direction: row;
    }

    > .right-section-bottom {
      width: 100%;

      > .box-contatiner-section {
        display: flex;
        flex-direction: row;
        width: 100%;
      }
    }
  }
}
.summary-block {
  position: relative;
  margin-bottom: 2px;
  margin-right: 3px;

  > .summary-item {
    border: 1px solid rgba(128, 128, 128, 0.5);
    max-width: 150px;
    min-width: 150px;
    max-height: 28px;
    min-height: 28px;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical;
    cursor: default;
    padding: 3px;
  }
  > .summary-item-printer {
    border: 1px solid rgba(128, 128, 128, 0.5);
    max-width: 100px;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    text-overflow: ellipsis;
    overflow: hidden;
    -webkit-box-orient: vertical;
    cursor: default;
    padding: 3px;
  }

  > .milestone-tooltip {
    position: absolute;
    text-overflow: wrap;
    height: 100%;
    width: 100%;
    top: 0;
    left: 0;
  }
}

.legend-items {
  display: flex;
  align-items: center;
  margin-right: 3px;

  > .legend-box {
    height: 10px;
    width: 10px;
    border: 1px solid rgba(128, 128, 128, 0.5);
    margin-right: 3px;
  }
}
.table-container {
  border: 1px solid rgba(0, 0, 0, 0.5);
  padding: 5px;
  margin-top: 3px;
  height: 100%;

  > .tabulator-title {
    display: flex;
    align-items: center;
    margin-bottom: 5px;

    > button {
      margin-left: 3px;
    }
  }
}

.ar-entryfields {
  height: calc(100% - 35px);
  width: 100%;
  overflow: scroll;
}

.total-block {
  border: 1px solid rgba(128, 128, 128, 0.5);
  max-width: 210px;
  min-width: 210px;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  cursor: default;
  padding: 3px;
}
> .button-filter-component {
  margin-right: 5px;
  position: relative;

  .filter-popup {
    display: flex;
    flex-direction: column;

    > button {
      margin-top: 5px;
      width: fit-content;
      align-self: flex-end;
    }
  }
}
.foreign-currency-style {
  position: relative;
  display: flex;
  align-items: center;
  min-height: 30px;
  flex-direction: row;
}

.api-loading {
  position: absolute;
  left: 0;
  top: 0;
  height: 90%;
  width: 55%;
  background-color: rgba(100, 100, 100, 0.7);
  z-index: 10;
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  &::before {
    content: 'Loading ' attr(name);
  }
}
</style>
